/* eslint-disable react/require-default-props */
import React, { ReactElement } from "react";
import { IconProps } from "../../model/common";
import { IconWrapper } from "../components/iconWrapper";

// ---------------------------------------- //
// ------------ Material Icons ------------ //
// ---------------------------------------- //

// ------------------------------------------- //
// ------------ Fontawesome Icons ------------ //
// ------------------------------------------- //

export function AlertIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 14.25H16.5L8.25 0L0 14.25ZM9 12H7.5V10.5H9V12ZM9 9H7.5V6H9V9Z"
          fill="#EE4549"
        />
      </svg>
    </IconWrapper>
  );
}

export function modalClose(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="modalClose"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.86547 0.972006C0.449344 1.38813 0.449344 2.0628 0.86547 2.47893L11.521 13.1345C11.9372 13.5506 12.6118 13.5506 13.0279 13.1345C13.4441 12.7184 13.4441 12.0437 13.0279 11.6276L2.37239 0.972006C1.95627 0.555881 1.28159 0.555881 0.86547 0.972006Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0279 0.972006C13.4441 1.38813 13.4441 2.0628 13.0279 2.47893L2.37239 13.1345C1.95627 13.5506 1.28159 13.5506 0.86547 13.1345C0.449344 12.7184 0.449344 12.0437 0.86547 11.6276L11.521 0.972006C11.9372 0.555881 12.6118 0.555881 13.0279 0.972006Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}

export function hamburgerIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        fill="#ffffff"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="26px"
        height="26px"
      >
        <path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z" />
      </svg>
    </IconWrapper>
  );
}
export function closeButton(): ReactElement {
  return (
    <IconWrapper>
      <svg
        fill="#000000"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
        width="30px"
        height="30px"
      >
        <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
      </svg>
    </IconWrapper>
  );
}
export function SearchIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10.5C1 5.25332 5.25332 1 10.5 1C15.7467 1 20 5.25332 20 10.5C20 12.7631 19.2086 14.8414 17.8875 16.4733L21.5607 20.1464C21.9512 20.537 21.9512 21.1701 21.5607 21.5607C21.1701 21.9512 20.537 21.9512 20.1464 21.5607L16.4733 17.8875C14.8414 19.2086 12.7631 20 10.5 20C5.25332 20 1 15.7467 1 10.5ZM10.5 3C6.35788 3 3 6.35788 3 10.5C3 14.6421 6.35788 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35788 14.6421 3 10.5 3Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}
export function whiteCloseButton({ fill = "currentcolor" }): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.195262 0.195262C0.455612 -0.0650874 0.877722 -0.0650874 1.13807 0.195262L4 3.05719L6.86193 0.195262C7.12228 -0.0650874 7.54439 -0.0650874 7.80474 0.195262C8.06509 0.455612 8.06509 0.877722 7.80474 1.13807L4.94281 4L7.80474 6.86193C8.06509 7.12228 8.06509 7.54439 7.80474 7.80474C7.54439 8.06509 7.12228 8.06509 6.86193 7.80474L4 4.94281L1.13807 7.80474C0.877722 8.06509 0.455612 8.06509 0.195262 7.80474C-0.0650874 7.54439 -0.0650874 7.12228 0.195262 6.86193L3.05719 4L0.195262 1.13807C-0.0650874 0.877722 -0.0650874 0.455612 0.195262 0.195262Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function tick({
  fill = "currentcolor",
  width = "17px",
}: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 14"
        width={width}
      >
        <path
          d="M6.0004 11.1996l-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4-10.6 10.6z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function downArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.04543 4.81694C4.29648 5.06102 4.70352 5.06102 4.95457 4.81694L8.81171 1.06694C9.06276 0.822864 9.06276 0.427136 8.81171 0.183058C8.56066 -0.0610194 8.15363 -0.0610194 7.90257 0.183058L4.5 3.49112L1.09743 0.183058C0.846375 -0.0610194 0.43934 -0.0610194 0.188289 0.183058C-0.0627628 0.427136 -0.0627628 0.822864 0.188289 1.06694L4.04543 4.81694Z"
          fill="#4182F1"
        />
      </svg>
    </IconWrapper>
  );
}

export function Info(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.55824 3.6804C7.55824 3.26854 7.22436 2.93466 6.8125 2.93466C6.40064 2.93466 6.06676 3.26854 6.06676 3.6804C6.06676 4.09225 6.40064 4.42614 6.8125 4.42614C7.22436 4.42614 7.55824 4.09225 7.55824 3.6804Z"
          fill="#4182F1"
        />
        <path
          d="M5.76847 5.61932C5.76847 5.28983 6.03557 5.02273 6.36506 5.02273H6.96165C7.29114 5.02273 7.55824 5.28983 7.55824 5.61932V9.19886H8.00568C8.33517 9.19886 8.60227 9.46597 8.60227 9.79545C8.60227 10.1249 8.33517 10.392 8.00568 10.392H5.91761C5.58813 10.392 5.32102 10.1249 5.32102 9.79545C5.32102 9.46597 5.58813 9.19886 5.91761 9.19886H6.36506V6.21591C6.03557 6.21591 5.76847 5.94881 5.76847 5.61932Z"
          fill="#4182F1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.8125 0.25C5.00049 0.25 3.35905 0.985188 2.17211 2.17211C0.985195 3.35905 0.25 5.00049 0.25 6.8125C0.25 8.62451 0.985188 10.266 2.17211 11.4529C3.35905 12.6398 5.00049 13.375 6.8125 13.375C8.62451 13.375 10.266 12.6398 11.4529 11.4529C12.6398 10.266 13.375 8.62451 13.375 6.8125C13.375 5.00049 12.6398 3.35905 11.4529 2.17211C10.266 0.985191 8.62451 0.25 6.8125 0.25ZM3.01581 3.01582C3.98814 2.04351 5.32966 1.44318 6.8125 1.44318C8.29535 1.44318 9.63686 2.04351 10.6092 3.01582C11.5815 3.98814 12.1818 5.32966 12.1818 6.8125C12.1818 8.29535 11.5815 9.63686 10.6092 10.6092C9.63686 11.5815 8.29535 12.1818 6.8125 12.1818C5.32966 12.1818 3.98814 11.5815 3.01582 10.6092C2.04351 9.63686 1.44318 8.29535 1.44318 6.8125C1.44318 5.32966 2.0435 3.98815 3.01581 3.01582Z"
          fill="#4182F1"
        />
      </svg>
    </IconWrapper>
  );
}

export function tick1(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z"
          fill="#21C276"
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.11581 3.60365C9.33458 3.78595 9.36413 4.11108 9.18183 4.32984L6.14579 7.9731C5.86136 8.3144 5.35502 8.36273 5.01117 8.0814L2.87345 6.33235C2.65305 6.15203 2.62057 5.82719 2.80089 5.60679C2.98121 5.3864 3.30606 5.35391 3.52646 5.53423L5.49419 7.1442L8.38963 3.66967C8.57193 3.45091 8.89705 3.42135 9.11581 3.60365Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}
export function Tick2(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.1967 2.19669C3.5532 0.840215 5.42913 0 7.5 0C9.57086 0 11.4468 0.840215 12.8033 2.1967L12.3212 2.67882L12.8033 2.1967C14.1598 3.5532 15 5.42913 15 7.5C15 9.57087 14.1598 11.4468 12.8033 12.8033C11.4468 14.1598 9.57087 15 7.5 15C5.42913 15 3.5532 14.1598 2.1967 12.8033L2.67882 12.3212L2.1967 12.8033C0.840215 11.4468 0 9.57086 0 7.5C0 5.42913 0.840215 3.5532 2.19669 2.1967L2.1967 2.19669ZM7.5 1.36364C5.80532 1.36364 4.27216 2.04973 3.16093 3.16094C2.04972 4.27217 1.36364 5.80532 1.36364 7.5C1.36364 9.19468 2.04973 10.7278 3.16094 11.8391C4.27216 12.9503 5.80532 13.6364 7.5 13.6364C9.19468 13.6364 10.7278 12.9503 11.8391 11.8391C12.9503 10.7278 13.6364 9.19468 13.6364 7.5C13.6364 5.80532 12.9503 4.27216 11.8391 3.16094C10.7278 2.04973 9.19468 1.36364 7.5 1.36364ZM11.3912 4.97243C11.6575 5.23869 11.6575 5.6704 11.3912 5.93666L7.3003 10.0276C7.03403 10.2938 6.60233 10.2938 6.33606 10.0276L4.29061 7.98212C4.02434 7.71585 4.02434 7.28415 4.29061 7.01788C4.55688 6.75162 4.98858 6.75162 5.25485 7.01788L6.81818 8.58122L10.427 4.97243C10.6932 4.70616 11.1249 4.70616 11.3912 4.97243Z"
          fill="#9197C0"
        />
      </svg>
    </IconWrapper>
  );
}
export function Add({ fill = "currentcolor" }: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1197_11420)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.0001 1.51358C8.0001 0.961296 7.55238 0.51358 7.0001 0.51358C6.44781 0.51358 6.0001 0.961296 6.0001 1.51358V6.50001H1.01367C0.461387 6.50001 0.0136719 6.94772 0.0136719 7.50001C0.0136719 8.05229 0.461387 8.50001 1.01367 8.50001H6.0001V13.4864C6.0001 14.0387 6.44781 14.4864 7.0001 14.4864C7.55238 14.4864 8.0001 14.0387 8.0001 13.4864V8.50001H12.9865C13.5388 8.50001 13.9865 8.05229 13.9865 7.50001C13.9865 6.94772 13.5388 6.50001 12.9865 6.50001H8.0001V1.51358Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_1197_11420">
            <rect
              width="14"
              height="14"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function PriorityIndicator(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.7 0L8.9595 1.33583L6.2755 4.1825L4.0755 1.84917L0 6.1775L0.7755 7L4.0755 3.5L6.2755 5.83333L9.7405 2.16417L11 3.5V0H7.7Z"
          fill="#EE786B"
        />
      </svg>
    </IconWrapper>
  );
}
export function InfoIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.77911 3.65909C7.77911 3.21978 7.42372 2.86364 6.98533 2.86364C6.54693 2.86364 6.19154 3.21978 6.19154 3.65909C6.19154 4.0984 6.54693 4.45455 6.98533 4.45455C7.42372 4.45455 7.77911 4.0984 7.77911 3.65909Z"
          fill="#505A65"
        />
        <path
          d="M5.87402 5.72727C5.87402 5.37582 6.15834 5.09091 6.50905 5.09091H7.14408C7.4948 5.09091 7.77911 5.37582 7.77911 5.72727V9.54545H8.25539C8.6061 9.54545 8.89042 9.83036 8.89042 10.1818C8.89042 10.5333 8.6061 10.8182 8.25539 10.8182H6.03278C5.68207 10.8182 5.39775 10.5333 5.39775 10.1818C5.39775 9.83036 5.68207 9.54545 6.03278 9.54545H6.50905V6.36364C6.15834 6.36364 5.87402 6.07873 5.87402 5.72727Z"
          fill="#505A65"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.98533 0C5.05657 0 3.30937 0.784201 2.04596 2.05025C0.782564 3.31631 0 5.06719 0 7C0 8.93281 0.782556 10.6837 2.04595 11.9497C3.30937 13.2158 5.05657 14 6.98533 14C8.91408 14 10.6613 13.2158 11.9247 11.9497C13.1881 10.6837 13.9707 8.93281 13.9707 7C13.9707 5.06719 13.1881 3.31632 11.9247 2.05025C10.6613 0.784204 8.91408 0 6.98533 0ZM2.94402 2.95021C3.97899 1.91308 5.40694 1.27273 6.98533 1.27273C8.56371 1.27273 9.99166 1.91308 11.0266 2.95021C12.0616 3.98735 12.7006 5.4183 12.7006 7C12.7006 8.5817 12.0616 10.0126 11.0266 11.0498C9.99166 12.0869 8.56371 12.7273 6.98533 12.7273C5.40694 12.7273 3.97899 12.0869 2.94402 11.0498C1.90907 10.0126 1.27006 8.5817 1.27006 7C1.27006 5.4183 1.90906 3.98736 2.94402 2.95021Z"
          fill="#505A65"
        />
      </svg>
    </IconWrapper>
  );
}
export function LinkIcon({ fill = "currentcolor" }: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.88224 0.933788C0.671479 2.14809 0.626194 4.11692 1.83667 5.33092L4.35242 7.85402C4.62427 8.12666 5.06501 8.12666 5.33685 7.85402C5.60869 7.58139 5.60869 7.13936 5.33685 6.86672L2.82109 4.34363C2.17902 3.69967 2.17454 2.61523 2.86667 1.92109C3.5588 1.22694 4.64008 1.23143 5.28216 1.87538L8.21721 4.81899L8.22167 4.82343C8.85929 5.46792 8.86214 6.54893 8.17162 7.24146C7.89978 7.51409 7.89978 7.95612 8.17162 8.22876C8.44346 8.50139 8.8842 8.50139 9.15605 8.22876C10.3668 7.01446 10.4121 5.04563 9.20162 3.83162L9.19627 3.82632L6.26659 0.88808C5.05611 -0.325926 3.09301 -0.280509 1.88224 0.933788Z"
          fill={fill}
        />
        <path
          d="M13.9908 13.0662C12.78 14.2805 10.8169 14.3259 9.60641 13.1119L6.67136 10.1683C6.66395 10.1609 6.65673 10.1533 6.64972 10.1456C6.64161 10.1382 6.63364 10.1306 6.6258 10.1227C5.41533 8.90872 5.46061 6.93989 6.67138 5.72559C6.94322 5.45296 7.38396 5.45296 7.65581 5.72559C7.92765 5.99823 7.92765 6.44026 7.65581 6.71289C6.96368 7.40704 6.96815 8.49148 7.61023 9.13543C7.61765 9.14287 7.62486 9.15043 7.63187 9.15811C7.63998 9.16552 7.64795 9.17315 7.65579 9.18101L10.5908 12.1246C11.2329 12.7686 12.3142 12.7731 13.0063 12.0789C13.6985 11.3848 13.694 10.3003 13.0519 9.65637L10.5361 7.13328C10.2643 6.86064 10.2643 6.41861 10.5361 6.14598C10.808 5.87334 11.2487 5.87334 11.5206 6.14598L14.0363 8.66908C15.2468 9.88308 15.2015 11.8519 13.9908 13.0662Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function ThreeDotsDropDown(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="3"
        height="14"
        viewBox="0 0 3 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          rx="1.24738"
          ry="1.25"
          transform="matrix(-1 0 0 1 1.75262 1.25)"
          fill="#505A65"
        />
        <ellipse
          rx="1.24738"
          ry="1.25"
          transform="matrix(-1 0 0 1 1.75262 6.69434)"
          fill="#505A65"
        />
        <ellipse
          rx="1.24738"
          ry="1.25"
          transform="matrix(-1 0 0 1 1.75262 12.75)"
          fill="#505A65"
        />
      </svg>
    </IconWrapper>
  );
}
export function refreshIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2 9.5625C17.2 13.5389 13.9764 16.7625 10 16.7625C8.01151 16.7625 6.21274 15.9576 4.90884 14.6537C4.65747 14.4023 4.29405 14.014 3.92527 13.6125H5.95C6.44706 13.6125 6.85 13.2096 6.85 12.7125C6.85 12.2154 6.44706 11.8125 5.95 11.8125H1.9C1.40294 11.8125 1 12.2154 1 12.7125V16.7625C1 17.2596 1.40294 17.6625 1.9 17.6625C2.39706 17.6625 2.8 17.2596 2.8 16.7625V15.0476C3.10914 15.3817 3.40907 15.6995 3.63604 15.9264C5.26371 17.5542 7.51495 18.5625 10 18.5625C14.9706 18.5625 19 14.5331 19 9.5625C19 8.67156 18.8705 7.81085 18.6294 6.99817L17.1716 8.91898C17.1904 9.13098 17.2 9.34562 17.2 9.5625Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.8 9C1.8 5.02356 5.02356 1.8 9 1.8C10.9885 1.8 12.7873 2.60491 14.0912 3.90884C14.3425 4.16021 14.706 4.54847 15.0747 4.95H13.05C12.5529 4.95 12.15 5.35294 12.15 5.85C12.15 6.34706 12.5529 6.75 13.05 6.75H17.1C17.5971 6.75 18 6.34706 18 5.85V1.8C18 1.30294 17.5971 0.9 17.1 0.9C16.6029 0.9 16.2 1.30294 16.2 1.8V3.51494C15.8909 3.18081 15.5909 2.86303 15.364 2.63606C13.7363 1.00834 11.485 0 9 0C4.02945 0 0 4.02945 0 9C0 9.89094 0.12946 10.7516 0.370594 11.5643L1.82837 9.64352C1.80959 9.43152 1.8 9.21688 1.8 9Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  );
}
export function info1(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.1364 5.22727C11.1364 4.59968 10.6276 4.09091 10 4.09091C9.37241 4.09091 8.86364 4.59968 8.86364 5.22727C8.86364 5.85486 9.37241 6.36364 10 6.36364C10.6276 6.36364 11.1364 5.85486 11.1364 5.22727Z"
          fill="#2B388F"
        />
        <path
          d="M8.40909 8.18182C8.40909 7.67974 8.8161 7.27273 9.31818 7.27273H10.2273C10.7293 7.27273 11.1364 7.67974 11.1364 8.18182V13.6364H11.8182C12.3203 13.6364 12.7273 14.0434 12.7273 14.5455C12.7273 15.0475 12.3203 15.4545 11.8182 15.4545H8.63636C8.13429 15.4545 7.72727 15.0475 7.72727 14.5455C7.72727 14.0434 8.13429 13.6364 8.63636 13.6364H9.31818V9.09091C8.8161 9.09091 8.40909 8.6839 8.40909 8.18182Z"
          fill="#2B388F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C7.23885 0 4.7376 1.12029 2.92894 2.92892C1.1203 4.73759 0 7.23885 0 10C0 12.7612 1.12029 15.2624 2.92893 17.0711C4.7376 18.8797 7.23884 20 10 20C12.7612 20 15.2624 18.8797 17.0711 17.0711C18.8797 15.2624 20 12.7612 20 10C20 7.23884 18.8797 4.7376 17.0711 2.92893C15.2624 1.12029 12.7612 0 10 0ZM4.21457 4.21458C5.69621 2.73297 7.74043 1.81818 10 1.81818C12.2596 1.81818 14.3038 2.73297 15.7854 4.21458C17.267 5.69622 18.1818 7.74043 18.1818 10C18.1818 12.2596 17.267 14.3038 15.7854 15.7854C14.3038 17.267 12.2596 18.1818 10 18.1818C7.74043 18.1818 5.69622 17.267 4.21458 15.7854C2.73297 14.3038 1.81818 12.2596 1.81818 10C1.81818 7.74043 2.73296 5.69622 4.21457 4.21458Z"
          fill="#2B388F"
        />
      </svg>
    </IconWrapper>
  );
}
export function Tick3(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.92894 2.92892C4.7376 1.12029 7.23885 0 10 0C12.7612 0 15.2624 1.12029 17.0711 2.92893L16.4282 3.57175L17.0711 2.92893C18.8797 4.7376 20 7.23884 20 10C20 12.7612 18.8797 15.2624 17.0711 17.0711C15.2624 18.8797 12.7612 20 10 20C7.23884 20 4.7376 18.8797 2.92893 17.0711L3.57175 16.4282L2.92893 17.0711C1.12029 15.2624 0 12.7612 0 10C0 7.23885 1.12029 4.7376 2.92892 2.92894L2.92894 2.92892ZM10 1.81818C7.74043 1.81818 5.69621 2.73297 4.21457 4.21458C2.73296 5.69623 1.81818 7.74043 1.81818 10C1.81818 12.2596 2.73297 14.3038 4.21458 15.7854C5.69622 17.267 7.74043 18.1818 10 18.1818C12.2596 18.1818 14.3038 17.267 15.7854 15.7854C17.267 14.3038 18.1818 12.2596 18.1818 10C18.1818 7.74043 17.267 5.69622 15.7854 4.21458C14.3038 2.73297 12.2596 1.81818 10 1.81818ZM15.1883 6.6299C15.5433 6.98493 15.5433 7.56053 15.1883 7.91555L9.73373 13.3701C9.37871 13.7251 8.80311 13.7251 8.44808 13.3701L5.72081 10.6428C5.36579 10.2878 5.36579 9.7122 5.72081 9.35718C6.07583 9.00215 6.65144 9.00215 7.00646 9.35718L9.09091 11.4416L13.9026 6.6299C14.2577 6.27488 14.8333 6.27488 15.1883 6.6299Z"
          fill="#0AB062"
        />
      </svg>
    </IconWrapper>
  );
}
export function ProgressBreakICon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="10"
        height="9"
        viewBox="0 0 10 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.50077 7.75C4.07812 8.75 5.52149 8.75 6.09884 7.75L9.12993 2.5C9.70728 1.5 8.98559 0.25 7.83089 0.25H1.76872C0.614015 0.25 -0.107673 1.5 0.469677 2.5L3.50077 7.75Z"
          fill="#2B388F"
        />
      </svg>
    </IconWrapper>
  );
}
export function LineDot(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r="4"
          transform="matrix(-1 0 0 1 5 5)"
          fill="#ADB1B7"
          stroke="#ADB1B7"
        />
      </svg>
    </IconWrapper>
  );
}
export function DragIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.44027 12L6 11.5866L6 0.393277L5.46075 5.53633e-08L0 5.62689L9.86074e-09 6.45378L5.44027 12Z"
          fill="#424242"
        />
        <path
          d="M9.55973 0L9 0.413445L9 11.6067L9.53925 12L15 6.37311V5.54622L9.55973 0Z"
          fill="#424242"
        />
      </svg>
    </IconWrapper>
  );
}
export function CloseIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.927037 0.927098C1.27417 0.579965 1.83698 0.579965 2.18412 0.927098L6.00002 4.743L9.81592 0.927098C10.1631 0.579965 10.7259 0.579965 11.073 0.927098C11.4201 1.27423 11.4201 1.83704 11.073 2.18418L7.2571 6.00008L11.073 9.81599C11.4201 10.1631 11.4201 10.7259 11.073 11.0731C10.7259 11.4202 10.1631 11.4202 9.81592 11.0731L6.00002 7.25716L2.18412 11.0731C1.83698 11.4202 1.27417 11.4202 0.927037 11.0731C0.579904 10.7259 0.579904 10.1631 0.927037 9.81599L4.74294 6.00008L0.927037 2.18418C0.579904 1.83704 0.579904 1.27423 0.927037 0.927098Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function ArrowBack(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM17 7L1 7V9L17 9V7Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function ZoomOutIcon({
  fill = "currentcolor",
}: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10.5C1 5.25332 5.25332 1 10.5 1C15.7467 1 20 5.25332 20 10.5C20 12.7631 19.2086 14.8414 17.8875 16.4733L21.5607 20.1464C21.9512 20.537 21.9512 21.1701 21.5607 21.5607C21.1701 21.9512 20.537 21.9512 20.1464 21.5607L16.4733 17.8875C14.8414 19.2086 12.7631 20 10.5 20C5.25332 20 1 15.7467 1 10.5ZM10.5 3C6.35788 3 3 6.35788 3 10.5C3 14.6421 6.35788 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35788 14.6421 3 10.5 3ZM6.5 10.5C6.5 9.94772 6.94772 9.5 7.5 9.5H13.5C14.0523 9.5 14.5 9.94772 14.5 10.5C14.5 11.0523 14.0523 11.5 13.5 11.5H7.5C6.94772 11.5 6.5 11.0523 6.5 10.5Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function ZoomInIcon({ fill = "currentcolor" }: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 10.5C1 5.25332 5.25332 1 10.5 1C15.7467 1 20 5.25332 20 10.5C20 12.7631 19.2086 14.8414 17.8875 16.4733L21.5607 20.1464C21.9512 20.537 21.9512 21.1701 21.5607 21.5607C21.1701 21.9512 20.537 21.9512 20.1464 21.5607L16.4733 17.8875C14.8414 19.2086 12.7631 20 10.5 20C5.25332 20 1 15.7467 1 10.5ZM10.5 3C6.35788 3 3 6.35788 3 10.5C3 14.6421 6.35788 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35788 14.6421 3 10.5 3ZM10.5 6.5C11.0523 6.5 11.5 6.94772 11.5 7.5V9.5H13.5C14.0523 9.5 14.5 9.94772 14.5 10.5C14.5 11.0523 14.0523 11.5 13.5 11.5H11.5V13.5C11.5 14.0523 11.0523 14.5 10.5 14.5C9.94772 14.5 9.5 14.0523 9.5 13.5V11.5H7.5C6.94772 11.5 6.5 11.0523 6.5 10.5C6.5 9.94772 6.94772 9.5 7.5 9.5H9.5V7.5C9.5 6.94772 9.94772 6.5 10.5 6.5Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function ProfileIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99935 2.49967C8.61864 2.49967 7.49935 3.61896 7.49935 4.99967C7.49935 6.38039 8.61864 7.49967 9.99935 7.49967C11.3801 7.49967 12.4993 6.38039 12.4993 4.99967C12.4993 3.61896 11.3801 2.49967 9.99935 2.49967ZM5.83268 4.99967C5.83268 2.69849 7.69816 0.833008 9.99935 0.833008C12.3005 0.833008 14.166 2.69849 14.166 4.99967C14.166 7.30086 12.3005 9.16634 9.99935 9.16634C7.69816 9.16634 5.83268 7.30086 5.83268 4.99967ZM1.66602 18.333C1.66602 13.7306 5.39699 9.99967 9.99935 9.99967C14.6017 9.99967 18.3327 13.7306 18.3327 18.333C18.3327 18.7932 17.9596 19.1663 17.4993 19.1663C17.0391 19.1663 16.666 18.7932 16.666 18.333C16.666 14.6511 13.6812 11.6663 9.99935 11.6663C6.31746 11.6663 3.33268 14.6511 3.33268 18.333C3.33268 18.7932 2.95959 19.1663 2.49935 19.1663C2.03911 19.1663 1.66602 18.7932 1.66602 18.333Z"
          fill="black"
          fillOpacity="0.85"
        />
      </svg>
    </IconWrapper>
  );
}
export function EditIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5649 1.33398C10.7418 1.33395 10.9114 1.40423 11.0365 1.52935L13.4715 3.96538C13.7317 4.22571 13.7317 4.64766 13.4715 4.90799L6.5772 11.8053C6.45217 11.9304 6.28255 12.0007 6.10569 12.0007H3.66663C3.29844 12.0007 2.99996 11.7022 2.99996 11.334V8.90729C2.99996 8.73061 3.07009 8.56116 3.19494 8.43616L10.0933 1.52953C10.2183 1.40436 10.388 1.33402 10.5649 1.33398ZM10.5652 2.94385L4.33329 9.18319V10.6673H5.82946L12.0574 4.43669L10.5652 2.94385ZM1.66663 14.0007C1.66663 13.6325 1.9651 13.334 2.33329 13.334H14.3333C14.7015 13.334 15 13.6325 15 14.0007C15 14.3688 14.7015 14.6673 14.3333 14.6673H2.33329C1.9651 14.6673 1.66663 14.3688 1.66663 14.0007Z"
          fill="currentcolor"
        />
      </svg>
    </IconWrapper>
  );
}
export function DeleteIcon({ fill = "currentcolor" }: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.125 10.8571C6.82124 10.8571 6.575 11.0917 6.575 11.381C6.575 11.6702 6.82124 11.9048 7.125 11.9048H9.875C10.1788 11.9048 10.425 11.6702 10.425 11.381C10.425 11.0917 10.1788 10.8571 9.875 10.8571H7.125Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.355 3C6.0871 3 5.85817 3.18383 5.81291 3.4353L5.56126 4.83333H3.55C3.24624 4.83333 3 5.06785 3 5.35714C3 5.64644 3.24624 5.88095 3.55 5.88095H4.40934L4.92614 13.5099C4.94481 13.7855 5.18499 14 5.475 14H11.525C11.815 14 12.0552 13.7855 12.0739 13.5099L12.5907 5.88095H13.45C13.7538 5.88095 14 5.64644 14 5.35714C14 5.06785 13.7538 4.83333 13.45 4.83333H11.4387L11.1871 3.4353C11.1418 3.18383 10.9129 3 10.645 3H6.355ZM10.3227 4.83333H6.67731L6.81874 4.04762H10.1813L10.3227 4.83333ZM5.99066 12.9524L5.51163 5.88095H11.4884L11.0093 12.9524H5.99066Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function CloseIcon2(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.927037 0.927098C1.27417 0.579965 1.83698 0.579965 2.18412 0.927098L6.00002 4.743L9.81592 0.927098C10.1631 0.579965 10.7259 0.579965 11.073 0.927098C11.4201 1.27423 11.4201 1.83704 11.073 2.18418L7.2571 6.00008L11.073 9.81599C11.4201 10.1631 11.4201 10.7259 11.073 11.0731C10.7259 11.4202 10.1631 11.4202 9.81592 11.0731L6.00002 7.25716L2.18412 11.0731C1.83698 11.4202 1.27417 11.4202 0.927037 11.0731C0.579904 10.7259 0.579904 10.1631 0.927037 9.81599L4.74294 6.00008L0.927037 2.18418C0.579904 1.83704 0.579904 1.27423 0.927037 0.927098Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function MoveIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.1957 0.287908C11.0111 0.103551 10.7609 0 10.5 0C10.2391 0 9.9889 0.103551 9.80432 0.287908L6.85095 3.24128C6.67705 3.4279 6.58239 3.67473 6.58688 3.92977C6.59138 4.18481 6.6947 4.42815 6.87507 4.60852C7.05544 4.78889 7.29878 4.8922 7.55382 4.8967C7.80886 4.9012 8.05569 4.80654 8.24231 4.63264L9.51554 3.35941V6.89033C9.51554 7.15142 9.61926 7.40182 9.80388 7.58644C9.98851 7.77106 10.2389 7.87478 10.5 7.87478C10.7611 7.87478 11.0115 7.77106 11.1961 7.58644C11.3807 7.40182 11.4845 7.15142 11.4845 6.89033V3.35941L12.7577 4.63264C12.8478 4.72936 12.9565 4.80694 13.0773 4.86075C13.198 4.91455 13.3284 4.94349 13.4606 4.94582C13.5927 4.94815 13.724 4.92383 13.8466 4.87432C13.9692 4.82481 14.0806 4.75111 14.174 4.65763C14.2675 4.56415 14.3412 4.4528 14.3907 4.33021C14.4402 4.20763 14.4646 4.07633 14.4622 3.94415C14.4599 3.81196 14.431 3.68161 14.3772 3.56085C14.3234 3.44009 14.2458 3.3314 14.1491 3.24128L11.1957 0.287908ZM0.287908 9.80432C0.103551 9.9889 0 10.2391 0 10.5C0 10.7609 0.103551 11.0111 0.287908 11.1957L3.24128 14.1491C3.4279 14.3229 3.67473 14.4176 3.92977 14.4131C4.18481 14.4086 4.42815 14.3053 4.60852 14.1249C4.78889 13.9446 4.8922 13.7012 4.8967 13.4462C4.9012 13.1911 4.80654 12.9443 4.63264 12.7577L3.35941 11.4845H6.89033C7.15142 11.4845 7.40182 11.3807 7.58644 11.1961C7.77106 11.0115 7.87478 10.7611 7.87478 10.5C7.87478 10.2389 7.77106 9.98851 7.58644 9.80388C7.40182 9.61926 7.15142 9.51554 6.89033 9.51554H3.35941L4.63264 8.24231C4.80654 8.05569 4.9012 7.80886 4.8967 7.55382C4.8922 7.29878 4.78889 7.05544 4.60852 6.87507C4.42815 6.6947 4.18481 6.59138 3.92977 6.58688C3.67473 6.58239 3.4279 6.67705 3.24128 6.85095L0.287908 9.80432ZM11.1957 20.7121L14.1491 17.7587C14.2458 17.6686 14.3234 17.5599 14.3772 17.4392C14.431 17.3184 14.4599 17.188 14.4622 17.0559C14.4646 16.9237 14.4402 16.7924 14.3907 16.6698C14.3412 16.5472 14.2675 16.4359 14.174 16.3424C14.0806 16.2489 13.9692 16.1752 13.8466 16.1257C13.724 16.0762 13.5927 16.0518 13.4606 16.0542C13.3284 16.0565 13.198 16.0854 13.0773 16.1393C12.9565 16.1931 12.8478 16.2706 12.7577 16.3674L11.4845 17.6406V14.1097C11.4845 13.8486 11.3807 13.5982 11.1961 13.4136C11.0115 13.2289 10.7611 13.1252 10.5 13.1252C10.2389 13.1252 9.98851 13.2289 9.80388 13.4136C9.61926 13.5982 9.51554 13.8486 9.51554 14.1097V17.6406L8.24231 16.3674C8.05569 16.1935 7.80886 16.0988 7.55382 16.1033C7.29878 16.1078 7.05544 16.2111 6.87507 16.3915C6.6947 16.5719 6.59138 16.8152 6.58688 17.0702C6.58239 17.3253 6.67705 17.5721 6.85095 17.7587L9.80432 20.7121C9.9889 20.8965 10.2391 21 10.5 21C10.7609 21 11.0111 20.8965 11.1957 20.7121ZM17.7587 6.85095L20.7121 9.80432C20.8965 9.9889 21 10.2391 21 10.5C21 10.7609 20.8965 11.0111 20.7121 11.1957L17.7587 14.1491C17.6686 14.2458 17.5599 14.3234 17.4392 14.3772C17.3184 14.431 17.188 14.4599 17.0559 14.4622C16.9237 14.4646 16.7924 14.4402 16.6698 14.3907C16.5472 14.3412 16.4359 14.2675 16.3424 14.174C16.2489 14.0806 16.1752 13.9692 16.1257 13.8466C16.0762 13.724 16.0518 13.5927 16.0542 13.4606C16.0565 13.3284 16.0854 13.198 16.1393 13.0773C16.1931 12.9565 16.2706 12.8478 16.3674 12.7577L17.6406 11.4845H14.1097C13.8486 11.4845 13.5982 11.3807 13.4136 11.1961C13.2289 11.0115 13.1252 10.7611 13.1252 10.5C13.1252 10.2389 13.2289 9.98851 13.4136 9.80388C13.5982 9.61926 13.8486 9.51554 14.1097 9.51554H17.6406L16.3674 8.24231C16.1935 8.05569 16.0988 7.80886 16.1033 7.55382C16.1078 7.29878 16.2111 7.05544 16.3915 6.87507C16.5719 6.6947 16.8152 6.59138 17.0702 6.58688C17.3253 6.58239 17.5721 6.67705 17.7587 6.85095Z"
          fill="#505A65"
        />
      </svg>
    </IconWrapper>
  );
}
export function LinkedinIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2452_16505)">
          <path
            d="M13.3779 12.0768H11.3035V9.06023C11.3035 8.34092 11.2897 7.41492 10.2246 7.41492C9.14424 7.41492 8.97892 8.19868 8.97892 9.00788V12.0766H6.90462V5.87335H8.89596V6.7211H8.92385C9.12314 6.40468 9.41112 6.14438 9.75712 5.96792C10.1031 5.79145 10.4942 5.70544 10.8887 5.71903C12.9911 5.71903 13.3788 7.00319 13.3788 8.67379L13.3779 12.0768V12.0768ZM4.564 5.02546C3.89916 5.02556 3.36011 4.52516 3.36 3.90782C3.35989 3.29047 3.89873 2.78992 4.56356 2.78982C5.2284 2.78966 5.76745 3.29006 5.76756 3.90741C5.76762 4.20387 5.64085 4.48822 5.41514 4.69789C5.18943 4.90756 4.88327 5.02539 4.564 5.02546V5.02546ZM5.6012 12.0768H3.52466V5.87335H5.60115V12.0768L5.6012 12.0768ZM14.412 1.00095H2.48232C1.91849 0.995056 1.45611 1.41446 1.44922 1.93801V13.0618C1.45589 13.5856 1.91822 14.0054 2.48227 13.9999H14.412C14.9773 14.0064 15.4414 13.5866 15.4492 13.0618V1.93715C15.4412 1.41258 14.977 0.993227 14.412 1.00008"
            fill="#0A66C2"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2452_16505"
            x="0.449219"
            y="0.5"
            width="16"
            height="15"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.5" />
            <feGaussianBlur stdDeviation="0.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2452_16505"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2452_16505"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </IconWrapper>
  );
}
export function UserCIrcleIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="22"
        height="21"
        viewBox="0 0 22 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0508 3C6.98503 3 3.55078 6.43425 3.55078 10.5C3.55078 14.5658 6.98503 18 11.0508 18C15.1165 18 18.5508 14.5658 18.5508 10.5C18.5508 6.43425 15.1165 3 11.0508 3ZM11.0508 6.75C12.346 6.75 13.3008 7.704 13.3008 9C13.3008 10.296 12.346 11.25 11.0508 11.25C9.75628 11.25 8.80078 10.296 8.80078 9C8.80078 7.704 9.75628 6.75 11.0508 6.75ZM7.22128 14.079C7.89403 13.089 9.01603 12.429 10.3008 12.429H11.8008C13.0863 12.429 14.2075 13.089 14.8803 14.079C13.9218 15.105 12.562 15.75 11.0508 15.75C9.53953 15.75 8.17978 15.105 7.22128 14.079Z"
          fill="#2B388F"
        />
      </svg>
    </IconWrapper>
  );
}
export function LogoipsumIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.9"
          x="1"
          y="1"
          width="8"
          height="8"
          fill="#4182F1"
          stroke="#2B388F"
          strokeWidth="0.72404"
        />
      </svg>
    </IconWrapper>
  );
}

export function PeersIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.58"
          x="1"
          y="1"
          width="8"
          height="8"
          fill="#A0A0BC"
          fillOpacity="1"
          stroke="#505A65"
          strokeDasharray="2 2"
        />
      </svg>
    </IconWrapper>
  );
}
export function shadeThree(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="1"
          x="1"
          y="1"
          width="12"
          height="12"
          fill="#144881"
          fillOpacity="1"
          stroke="#144881"
          strokeDasharray="2 2"
        />
      </svg>
    </IconWrapper>
  );
}
export function shadeTwo(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="1"
          x="1"
          y="1"
          width="12"
          height="12"
          fill="#4182F1"
          fillOpacity="1"
          stroke="#4182F1"
          strokeDasharray="2 2"
        />
      </svg>
    </IconWrapper>
  );
}
export function shadeOne(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="1"
          x="1"
          y="1"
          width="12"
          height="12"
          fill="#AFCBF9"
          fillOpacity="1"
          stroke="#AFCBF9"
          strokeDasharray="2 2"
        />
      </svg>
    </IconWrapper>
  );
}
export function MoveIconSmall({
  fill = "currentcolor",
}: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.86441 0.150809C5.76772 0.0542411 5.63665 0 5.5 0C5.36335 0 5.23228 0.0542411 5.1356 0.150809L3.58859 1.69781C3.4975 1.79556 3.44792 1.92486 3.45027 2.05845C3.45263 2.19204 3.50675 2.31951 3.60123 2.41399C3.69571 2.50846 3.82317 2.56258 3.95676 2.56494C4.09036 2.5673 4.21965 2.51771 4.3174 2.42662L4.98433 1.75969V3.60922C4.98433 3.74598 5.03866 3.87714 5.13537 3.97385C5.23207 4.07056 5.36324 4.12489 5.5 4.12489C5.63676 4.12489 5.76793 4.07056 5.86463 3.97385C5.96134 3.87714 6.01567 3.74598 6.01567 3.60922V1.75969L6.6826 2.42662C6.72981 2.47729 6.78674 2.51792 6.84999 2.54611C6.91325 2.57429 6.98153 2.58945 7.05077 2.59067C7.12001 2.59189 7.18878 2.57915 7.25299 2.55322C7.3172 2.52728 7.37553 2.48868 7.4245 2.43971C7.47346 2.39074 7.51207 2.33242 7.538 2.26821C7.56394 2.204 7.57667 2.13522 7.57545 2.06598C7.57423 1.99674 7.55908 1.92846 7.53089 1.86521C7.50271 1.80195 7.46207 1.74502 7.41141 1.69781L5.86441 0.150809ZM0.150809 5.1356C0.0542411 5.23228 0 5.36335 0 5.5C0 5.63665 0.0542411 5.76772 0.150809 5.86441L1.69781 7.41141C1.79556 7.5025 1.92486 7.55208 2.05845 7.54973C2.19204 7.54737 2.31951 7.49325 2.41399 7.39877C2.50846 7.30429 2.56258 7.17683 2.56494 7.04324C2.5673 6.90964 2.51771 6.78035 2.42662 6.6826L1.75969 6.01567H3.60922C3.74598 6.01567 3.87714 5.96134 3.97385 5.86463C4.07056 5.76793 4.12489 5.63676 4.12489 5.5C4.12489 5.36324 4.07056 5.23207 3.97385 5.13537C3.87714 5.03866 3.74598 4.98433 3.60922 4.98433H1.75969L2.42662 4.3174C2.51771 4.21965 2.5673 4.09036 2.56494 3.95676C2.56258 3.82317 2.50846 3.69571 2.41399 3.60123C2.31951 3.50675 2.19204 3.45263 2.05845 3.45027C1.92486 3.44792 1.79556 3.4975 1.69781 3.58859L0.150809 5.1356ZM5.86441 10.8492L7.41141 9.30219C7.46207 9.25498 7.50271 9.19805 7.53089 9.1348C7.55908 9.07154 7.57423 9.00326 7.57545 8.93402C7.57667 8.86478 7.56394 8.796 7.538 8.73179C7.51207 8.66758 7.47346 8.60926 7.4245 8.56029C7.37553 8.51132 7.3172 8.47272 7.25299 8.44678C7.18878 8.42085 7.12001 8.40811 7.05077 8.40933C6.98153 8.41055 6.91325 8.42571 6.84999 8.45389C6.78674 8.48208 6.72981 8.52272 6.6826 8.57338L6.01567 9.24031V7.39078C6.01567 7.25402 5.96134 7.12286 5.86463 7.02615C5.76793 6.92944 5.63676 6.87511 5.5 6.87511C5.36324 6.87511 5.23207 6.92944 5.13537 7.02615C5.03866 7.12286 4.98433 7.25402 4.98433 7.39078V9.24031L4.3174 8.57338C4.21965 8.48229 4.09036 8.4327 3.95676 8.43506C3.82317 8.43742 3.69571 8.49154 3.60123 8.58601C3.50675 8.68049 3.45263 8.80796 3.45027 8.94155C3.44792 9.07514 3.4975 9.20444 3.58859 9.30219L5.1356 10.8492C5.23228 10.9458 5.36335 11 5.5 11C5.63665 11 5.76772 10.9458 5.86441 10.8492ZM9.30219 3.58859L10.8492 5.1356C10.9458 5.23228 11 5.36335 11 5.5C11 5.63665 10.9458 5.76772 10.8492 5.86441L9.30219 7.41141C9.25498 7.46207 9.19805 7.50271 9.1348 7.53089C9.07154 7.55908 9.00326 7.57423 8.93402 7.57545C8.86478 7.57667 8.796 7.56394 8.73179 7.538C8.66758 7.51207 8.60926 7.47346 8.56029 7.4245C8.51132 7.37553 8.47272 7.3172 8.44678 7.25299C8.42085 7.18878 8.40811 7.12001 8.40933 7.05077C8.41055 6.98153 8.42571 6.91325 8.45389 6.84999C8.48208 6.78674 8.52272 6.72981 8.57338 6.6826L9.24031 6.01567H7.39078C7.25402 6.01567 7.12286 5.96134 7.02615 5.86463C6.92944 5.76793 6.87511 5.63676 6.87511 5.5C6.87511 5.36324 6.92944 5.23207 7.02615 5.13537C7.12286 5.03866 7.25402 4.98433 7.39078 4.98433H9.24031L8.57338 4.3174C8.48229 4.21965 8.4327 4.09036 8.43506 3.95676C8.43742 3.82317 8.49154 3.69571 8.58601 3.60123C8.68049 3.50675 8.80796 3.45263 8.94155 3.45027C9.07514 3.44792 9.20444 3.4975 9.30219 3.58859Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function AddIconBlack(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.77246 0.75C5.77246 0.335786 5.43667 0 5.02246 0C4.60825 0 4.27246 0.335786 4.27246 0.75V4.27246H0.75C0.335786 4.27246 0 4.60825 0 5.02246C0 5.43667 0.335786 5.77246 0.75 5.77246H4.27246V9.29539C4.27246 9.70961 4.60825 10.0454 5.02246 10.0454C5.43667 10.0454 5.77246 9.70961 5.77246 9.29539V5.77246H9.29539C9.70961 5.77246 10.0454 5.43667 10.0454 5.02246C10.0454 4.60825 9.70961 4.27246 9.29539 4.27246H5.77246V0.75Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}

export function UserIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5 3.87533C13.3599 3.87533 11.625 5.61022 11.625 7.75033C11.625 9.89043 13.3599 11.6253 15.5 11.6253C17.6401 11.6253 19.375 9.89043 19.375 7.75033C19.375 5.61022 17.6401 3.87533 15.5 3.87533ZM9.04171 7.75033C9.04171 4.18349 11.9332 1.29199 15.5 1.29199C19.0669 1.29199 21.9584 4.18349 21.9584 7.75033C21.9584 11.3172 19.0669 14.2087 15.5 14.2087C11.9332 14.2087 9.04171 11.3172 9.04171 7.75033ZM2.58337 28.417C2.58337 21.2833 8.36638 15.5003 15.5 15.5003C22.6337 15.5003 28.4167 21.2833 28.4167 28.417C28.4167 29.1304 27.8384 29.7087 27.125 29.7087C26.4117 29.7087 25.8334 29.1304 25.8334 28.417C25.8334 23.3229 22.1472 19.0897 17.2968 18.2393L19.3179 24.808C19.4436 25.2166 19.3591 25.6609 19.092 25.9947L16.5087 29.2239C16.2635 29.5303 15.8924 29.7087 15.5 29.7087C15.1077 29.7087 14.7365 29.5303 14.4914 29.2239L11.9081 25.9947C11.641 25.6609 11.5564 25.2166 11.6822 24.808L13.7033 18.2393C8.85284 19.0897 5.16671 23.3229 5.16671 28.417C5.16671 29.1304 4.58841 29.7087 3.87504 29.7087C3.16167 29.7087 2.58337 29.1304 2.58337 28.417ZM15.5 21.1841L14.3522 24.9145L15.5 26.3493L16.6479 24.9145L15.5 21.1841Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}
export function JobIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.33337 3.33333C1.33337 2.59695 1.93033 2 2.66671 2H29.3334C30.0698 2 30.6667 2.59695 30.6667 3.33333V28.1146C30.6667 28.2092 30.6569 28.3015 30.6381 28.3905C30.6569 28.4796 30.6668 28.572 30.6668 28.6667C30.6668 29.403 30.0698 30 29.3334 30H8.67711C7.94073 30 7.34377 29.403 7.34377 28.6667C7.34377 27.9303 7.94073 27.3333 8.67711 27.3333H28V12.6667H4.00004V20.1146C4.00004 20.851 3.40309 21.4479 2.66671 21.4479C1.93033 21.4479 1.33337 20.851 1.33337 20.1146V3.33333ZM4.00004 10V4.66667H28V10H4.00004ZM5.33337 7.33107C5.33337 6.59469 5.93033 5.99773 6.66671 5.99773H7.33337C8.06975 5.99773 8.66671 6.59469 8.66671 7.33107C8.66671 8.06745 8.06975 8.6644 7.33337 8.6644H6.66671C5.93033 8.6644 5.33337 8.06745 5.33337 7.33107ZM10 7.33333C10 6.59695 10.597 6 11.3334 6H25.3334C26.0698 6 26.6667 6.59695 26.6667 7.33333C26.6667 8.06971 26.0698 8.66667 25.3334 8.66667H11.3334C10.597 8.66667 10 8.06971 10 7.33333ZM19.5901 17.0564C20.1063 16.5411 20.9407 16.5362 21.4629 17.0453L24.4499 19.9573C24.9772 20.4713 24.9879 21.3155 24.4739 21.8427C23.9599 22.37 23.1157 22.3808 22.5884 21.8667L20.5433 19.873L16.112 24.297C15.5991 24.809 14.7712 24.8176 14.2478 24.3164L10.8088 21.0229L3.61433 28.2914C3.0963 28.8147 2.25209 28.819 1.72873 28.301C1.20538 27.783 1.20106 26.9388 1.71909 26.4154L9.83615 18.2149C10.3481 17.6976 11.1803 17.6865 11.706 18.1899L15.1506 21.4887L19.5901 17.0564Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}

export function ProgressIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.4 5.7781C3.90294 5.7781 3.5 6.1512 3.5 6.61144C3.5 7.07167 3.90294 7.44477 4.4 7.44477C4.89706 7.44477 5.3 7.07167 5.3 6.61144C5.3 6.1512 4.89706 5.7781 4.4 5.7781ZM2.3 6.61144C2.3 5.53755 3.2402 4.66699 4.4 4.66699C5.5598 4.66699 6.5 5.53755 6.5 6.61144C6.5 7.68532 5.5598 8.55588 4.4 8.55588C3.2402 8.55588 2.3 7.68532 2.3 6.61144ZM7.4 5.22255C7.4 4.91572 7.66863 4.66699 8 4.66699H13.4C13.7314 4.66699 14 4.91572 14 5.22255C14 5.52937 13.7314 5.7781 13.4 5.7781H8C7.66863 5.7781 7.4 5.52937 7.4 5.22255ZM7.4 8.00033C7.4 7.6935 7.66863 7.44477 8 7.44477H13.4C13.7314 7.44477 14 7.6935 14 8.00033C14 8.30715 13.7314 8.55588 13.4 8.55588H8C7.66863 8.55588 7.4 8.30715 7.4 8.00033ZM2 10.7781C2 10.4713 2.26863 10.2225 2.6 10.2225H13.4C13.7314 10.2225 14 10.4713 14 10.7781C14 11.0849 13.7314 11.3337 13.4 11.3337H2.6C2.26863 11.3337 2 11.0849 2 10.7781Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}

export function CalenderIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.6665 0.666992C6.03469 0.666992 6.33317 0.965469 6.33317 1.33366V2.00033H9.6665V1.33366C9.6665 0.965469 9.96498 0.666992 10.3332 0.666992C10.7014 0.666992 10.9998 0.965469 10.9998 1.33366V2.00033H13.9998C14.7362 2.00033 15.3332 2.59728 15.3332 3.33366V14.0003C15.3332 14.7367 14.7362 15.3337 13.9998 15.3337H1.99984C1.26346 15.3337 0.666504 14.7367 0.666504 14.0003V3.33366C0.666504 2.59728 1.26346 2.00033 1.99984 2.00033H4.99984V1.33366C4.99984 0.965469 5.29831 0.666992 5.6665 0.666992ZM4.99984 3.33366H1.99984V6.00032H13.9998V3.33366H10.9998V4.00032C10.9998 4.36851 10.7014 4.66699 10.3332 4.66699C9.96498 4.66699 9.6665 4.36851 9.6665 4.00032V3.33366H6.33317V4.00032C6.33317 4.36851 6.03469 4.66699 5.6665 4.66699C5.29831 4.66699 4.99984 4.36851 4.99984 4.00032V3.33366ZM13.9998 7.33366H10.9998V10.0003H13.9998V7.33366ZM13.9998 11.3337H10.9998V14.0003H13.9998V11.3337ZM9.6665 14.0003V11.3337H6.33317V14.0003H9.6665ZM4.99984 14.0003V11.3337H1.99984V14.0003H4.99984ZM1.99984 10.0003H4.99984V7.33366H1.99984V10.0003ZM6.33317 7.33366V10.0003H9.6665V7.33366H6.33317Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function AddIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#4182F1" />
        <path
          d="M16 11C16.5523 11 17 11.4477 17 12V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H15V12C15 11.4477 15.4477 11 16 11Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}
export function HighIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="11"
        height="7"
        viewBox="0 0 11 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.26275 0.176758C8.10032 0.176758 8.01584 0.370283 8.12629 0.489388L8.92652 1.35238C8.9927 1.42375 8.9927 1.53407 8.92652 1.60545L6.60722 4.10665C6.53358 4.18606 6.40794 4.18606 6.3343 4.10665L4.49822 2.12656C4.42455 2.04711 4.29884 2.04715 4.22522 2.12666L0.571757 6.07198C0.505654 6.14337 0.505691 6.25362 0.571842 6.32496L1.06158 6.85311C1.13523 6.93253 1.26086 6.93253 1.3345 6.85311L4.22522 3.73568C4.29886 3.65626 4.42449 3.65626 4.49813 3.73568L6.33441 5.71598C6.40801 5.79535 6.53356 5.7954 6.60723 5.71609L9.65611 2.4333C9.72977 2.35398 9.85532 2.35403 9.92892 2.43341L10.6775 3.24066C10.7925 3.36473 11 3.28333 11 3.11413V0.362854C11 0.260076 10.9167 0.176758 10.8139 0.176758H8.26275Z"
          fill="#EE786B"
        />
      </svg>
    </IconWrapper>
  );
}
export function AccordionUpArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.04543 0.163445C4.29648 -0.0544816 4.70352 -0.0544816 4.95457 0.163445L8.81171 3.51166C9.06276 3.72959 9.06276 4.08291 8.81171 4.30084C8.56066 4.51877 8.15363 4.51877 7.90257 4.30084L4.5 1.34722L1.09743 4.30084C0.846375 4.51877 0.43934 4.51877 0.188289 4.30084C-0.0627628 4.08291 -0.0627628 3.72959 0.188289 3.51166L4.04543 0.163445Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function AccordionDownArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.04543 4.83645C4.29648 5.05437 4.70352 5.05437 4.95457 4.83645L8.81171 1.48823C9.06276 1.27031 9.06276 0.916978 8.81171 0.699052C8.56066 0.481125 8.15363 0.481125 7.90257 0.699052L4.5 3.65268L1.09743 0.699052C0.846375 0.481125 0.43934 0.481125 0.188289 0.699052C-0.0627628 0.916978 -0.0627628 1.27031 0.188289 1.48823L4.04543 4.83645Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}
export function arrowRightIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="32"
        height="8"
        viewBox="0 0 32 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.3536 4.35355C31.5488 4.15829 31.5488 3.84171 31.3536 3.64645L28.1716 0.464466C27.9763 0.269204 27.6597 0.269204 27.4645 0.464466C27.2692 0.659728 27.2692 0.976311 27.4645 1.17157L30.2929 4L27.4645 6.82843C27.2692 7.02369 27.2692 7.34027 27.4645 7.53553C27.6597 7.7308 27.9763 7.7308 28.1716 7.53553L31.3536 4.35355ZM0 4.5H31V3.5H0V4.5Z"
          fill="black"
        />
      </svg>
    </IconWrapper>
  );
}

export function UnAssignedIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5002 0.746704C15.9604 0.746704 16.3335 1.1198 16.3335 1.58004C16.3335 2.04027 15.9604 2.41337 15.5002 2.41337H2.16683C1.70659 2.41337 1.3335 2.04027 1.3335 1.58004C1.3335 1.1198 1.70659 0.746704 2.16683 0.746704H15.5002Z"
          fill="currentcolor"
        />
        <path
          d="M15.5002 6.16337C15.9604 6.16337 16.3335 6.53647 16.3335 6.9967C16.3335 7.45694 15.9604 7.83004 15.5002 7.83004H3.34542L4.27973 8.76436C4.60517 9.0898 4.60516 9.61744 4.27972 9.94287C3.95428 10.2683 3.42664 10.2683 3.10121 9.94286L0.752364 7.59397C0.683201 7.52667 0.625687 7.44745 0.583134 7.35964C0.537063 7.26456 0.508529 7.15941 0.501738 7.04838C0.498865 7.00198 0.499855 6.95538 0.504709 6.90912C0.509825 6.86014 0.519183 6.81243 0.532408 6.76636C0.57006 6.63489 0.64066 6.51087 0.744209 6.40732L3.10121 4.05028C3.42664 3.72484 3.95428 3.72483 4.27972 4.05027C4.60516 4.3757 4.60517 4.90334 4.27973 5.22878L3.34515 6.16337H15.5002Z"
          fill="currentcolor"
        />
        <path
          d="M16.3335 12.4134C16.3335 11.9531 15.9604 11.58 15.5002 11.58H2.16683C1.70659 11.58 1.3335 11.9531 1.3335 12.4134C1.3335 12.8736 1.70659 13.2467 2.16683 13.2467H15.5002C15.9604 13.2467 16.3335 12.8736 16.3335 12.4134Z"
          fill="currentcolor"
        />
      </svg>
    </IconWrapper>
  );
}
export function DragImage(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="59"
        height="59"
        viewBox="0 0 59 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.64124 0.281287C4.2224 0.700124 4.26614 1.45285 4.73055 1.8181C5.0702 2.08532 5.28792 2.10965 7.33878 2.10965C9.5272 2.10965 9.58416 2.10206 9.9217 1.76437C10.3647 1.32149 10.373 0.711235 9.94153 0.305759C9.63409 0.0170179 9.48515 0 7.26931 0C5.11 0 4.90002 0.022503 4.64124 0.281287ZM12.2605 0.325449C11.8549 0.757366 11.8707 1.33513 12.3 1.76437C12.6375 2.10206 12.6945 2.10965 14.8829 2.10965C16.9338 2.10965 17.1515 2.08532 17.4911 1.8181C17.9556 1.45285 17.9993 0.700124 17.5805 0.281287C17.3214 0.0222217 17.1117 0 14.9327 0C12.641 0 12.5567 0.0102669 12.2605 0.325449ZM19.841 0.370596C19.4542 0.862145 19.4728 1.34258 19.8947 1.76437C20.2323 2.10206 20.2893 2.10965 22.4777 2.10965C24.5285 2.10965 24.7462 2.08532 25.0859 1.8181C25.5503 1.45285 25.594 0.700124 25.1752 0.281287C24.9161 0.0222217 24.7064 0 22.5132 0H20.1324L19.841 0.370596ZM27.4247 0.38452C27.0615 0.846253 27.1299 1.48801 27.5822 1.86353C27.838 2.07604 28.1892 2.10909 30.1485 2.10515C32.5878 2.10037 32.7794 2.05101 33.0423 1.35988C33.2164 0.901947 33.0385 0.359626 32.6454 0.149223C32.4811 0.0613207 31.413 0 30.0468 0H27.7272L27.4247 0.38452ZM34.9041 1.30995C34.4443 1.79954 34.5042 2.42568 35.0715 3.05858C35.7103 3.77136 35.9709 4.31776 36.0861 5.18637C36.2457 6.38958 37.1789 6.85539 37.9284 6.1059C38.2572 5.77708 38.2849 5.66625 38.2172 4.94559C38.0999 3.69555 37.6298 2.63946 36.7994 1.76156C35.9558 0.869318 35.4347 0.74527 34.9041 1.30995ZM1.22979 1.93385C0.520241 2.6756 0.0895898 3.87712 0.0257376 5.29326C-0.0267225 6.45681 -0.00407844 6.60617 0.265254 6.8755C0.65779 7.26804 1.41445 7.27113 1.76719 6.88155C1.95523 6.67368 2.0586 6.26666 2.1278 5.46189C2.20628 4.54785 2.30726 4.2006 2.65943 3.63423C3.18009 2.7967 3.2123 2.26971 2.76871 1.85284C2.31106 1.42289 1.68702 1.4558 1.22979 1.93385ZM36.4512 8.48278C36.1627 8.78995 36.1454 8.93987 36.1454 11.1305C36.1454 13.3761 36.1561 13.4628 36.4709 13.7586C36.9315 14.1912 37.5949 14.1625 37.9635 13.6938C38.2305 13.3545 38.2551 13.1361 38.2551 11.1108C38.2551 9.08558 38.2305 8.86716 37.9635 8.52793C37.5825 8.04355 36.8835 8.02273 36.4512 8.48278ZM0.38452 9.14099L0 9.44352V11.8087C0 13.8576 0.0329106 14.2125 0.246126 14.4622C0.637959 14.9214 1.39392 14.9202 1.82288 14.4597C2.08701 14.1763 2.10965 13.9721 2.10965 11.8734C2.10965 9.91017 2.07562 9.55392 1.86353 9.29851C1.48801 8.8462 0.846253 8.77785 0.38452 9.14099ZM32.1179 15.1366C31.7981 15.2501 31.297 15.5497 31.0046 15.8026C30.3263 16.3889 30.2712 17.0296 30.8557 17.5324C31.3505 17.9579 31.5663 17.9451 32.4184 17.4398C33.639 16.7158 33.9841 16.8476 35.811 18.736C37.9452 20.9421 39.468 23.1497 40.8491 26.0395C42.1747 28.8131 42.2585 29.1459 42.26 31.6448C42.2616 33.8059 42.2572 33.8358 41.7669 35.0906C40.8919 37.3306 39.456 39.0684 37.4445 40.3221C34.8653 41.9295 31.1021 42.49 28.5837 41.6416C27.6726 41.3347 20.2516 37.2354 19.4143 36.5766C19.1465 36.3659 18.7778 35.9138 18.5948 35.5717C18.3183 35.055 18.2706 34.7907 18.3122 34.0082C18.3398 33.4902 18.4086 33.0202 18.4651 32.9636C18.5216 32.9071 19.1912 33.4733 19.9531 34.2218C20.7151 34.9703 21.4393 35.5828 21.5625 35.5828C22.1912 35.5828 22.7843 34.9859 22.7843 34.3535C22.7843 34.226 21.5278 32.8524 19.9919 31.3011C18.4561 29.7496 17.0954 28.3238 16.9681 28.1325C16.8363 27.9348 16.7366 27.5034 16.7366 27.1318C16.7366 26.3421 17.09 25.8286 17.7937 25.5964C18.7028 25.2963 19.1205 25.5663 21.7455 28.1502C24.3617 30.7256 24.5768 30.8496 25.2519 30.1744C25.9523 29.4741 25.8347 29.2816 22.9601 26.4199C20.4535 23.9246 20.2818 23.7827 19.4897 23.5536C16.4327 22.6694 13.7631 25.35 14.7082 28.3549C14.9119 29.0025 15.1677 29.3855 15.9389 30.1973L16.9123 31.222L16.608 31.9292C15.9175 33.5344 15.9442 35.1425 16.6858 36.6059C17.3158 37.849 17.9747 38.3369 22.3806 40.8224C27.0842 43.4756 27.377 43.6163 28.9014 43.9555C30.3723 44.2826 33.3188 44.1798 34.9499 43.7444C41.0909 42.1049 45.1999 36.2889 44.4615 30.2811C43.9631 26.2251 40.9994 20.8722 37.0707 16.9319C35.8091 15.6667 35.3806 15.3252 34.8194 15.1387C33.9792 14.8593 32.9026 14.8584 32.1179 15.1366ZM0.606877 16.5969C0.0774944 16.8103 0 17.1823 0 19.509C0 21.9287 0.0843862 22.2471 0.77143 22.4196C1.18113 22.5224 1.89053 22.2072 2.02232 21.8638C2.07027 21.7386 2.10965 20.6655 2.10965 19.4791C2.10965 18.2928 2.07027 17.2197 2.02232 17.0945C1.93835 16.8757 1.25918 16.4457 1.0267 16.4642C0.964815 16.4691 0.775931 16.5289 0.606877 16.5969ZM26.2649 17.0694C25.1294 17.493 24.3485 18.3765 24.5498 19.0102C24.6766 19.4101 25.1865 19.8308 25.544 19.8308C25.7177 19.8308 26.1788 19.6323 26.569 19.3898C27.7611 18.6488 27.9284 18.7309 30.5799 21.3563C31.823 22.5875 32.9874 23.6397 33.1671 23.6945C33.9469 23.9326 34.7668 23.0927 34.4768 22.3531C34.2929 21.8837 29.864 17.5339 29.2539 17.2232C28.6059 16.8933 26.9636 16.8087 26.2649 17.0694ZM21.3863 20.1544C20.7492 20.3576 19.6901 21.3766 19.6901 21.7865C19.6901 21.9604 19.8815 22.2941 20.1156 22.5282C20.6043 23.0169 20.9088 22.9987 21.7455 22.4308C22.4135 21.9775 23.1439 21.9716 23.7446 22.4148C23.9934 22.5983 25.0624 23.611 26.1202 24.6651C28.232 26.7695 28.513 26.9134 29.1899 26.2364C29.8653 25.561 29.7345 25.3264 27.32 22.8833C24.7575 20.2904 24.2501 19.9663 22.7843 19.9871C22.2815 19.9943 21.6524 20.0696 21.3863 20.1544ZM47.4291 20.9093C47.1302 21.0296 46.8218 21.7712 46.9155 22.1443C47.0862 22.8248 47.2176 22.8501 50.9692 22.9267C54.2613 22.994 54.5386 23.0198 55.0821 23.3087C55.8445 23.7141 56.6053 24.6164 56.8088 25.3569C56.9283 25.7917 56.9607 29.7605 56.931 40.3055L56.8903 54.6623L56.4648 55.3506C56.2009 55.7773 55.7773 56.2009 55.3506 56.4648L54.6623 56.8903L40.3055 56.931C29.7605 56.9607 25.7917 56.9283 25.3569 56.8088C24.6169 56.6054 23.7146 55.8451 23.3077 55.0821C23.0151 54.533 22.993 54.2773 22.9258 50.6552C22.8591 47.0572 22.8372 46.7983 22.5816 46.6117C22.128 46.2806 21.439 46.3605 21.1068 46.783C20.829 47.136 20.8153 47.3243 20.8153 50.7657C20.8153 53.6515 20.8601 54.5316 21.0386 55.1419C21.4857 56.6708 22.584 57.9498 24.0332 58.6294L24.8236 59H39.9457H55.0679L55.9939 58.5442C57.109 57.9951 58.0968 56.9892 58.6231 55.8662L59 55.062V39.9428V24.8236L58.6294 24.0332C57.9498 22.584 56.6708 21.4857 55.1419 21.0386C54.5319 20.8603 53.696 20.8175 50.9929 20.8264C49.1312 20.8324 47.5274 20.8698 47.4291 20.9093ZM0.612643 24.2599C0.376222 24.3593 0.141628 24.5478 0.0914186 24.6789C0.0410682 24.8098 0 25.9514 0 27.2158V29.5148L0.370596 29.8062C0.862145 30.193 1.34258 30.1744 1.76437 29.7525C2.10318 29.4138 2.10951 29.364 2.10515 27.1154C2.10037 24.6714 2.04876 24.4616 1.38886 24.2108C1.15201 24.1207 0.90687 24.1363 0.612643 24.2599ZM0.263707 32.0843C0.00168772 32.3463 -0.026863 32.5002 0.032348 33.3283C0.115328 34.4888 0.601533 35.6076 1.39884 36.4725C2.07449 37.2056 2.51204 37.3606 3.07827 37.0678C3.85673 36.6652 3.86292 35.9409 3.09514 35.108C2.51274 34.476 2.10965 33.578 2.10965 32.9119C2.10965 32.6999 1.97843 32.3598 1.8181 32.1561C1.44553 31.6824 0.700124 31.6479 0.263707 32.0843ZM5.35472 36.516C4.96795 37.0076 4.98652 37.488 5.40845 37.9098C5.74684 38.2483 5.79902 38.2551 8.05607 38.2551C10.281 38.2551 10.369 38.2441 10.6644 37.9296C11.0536 37.5153 11.0653 36.8031 10.6889 36.4267C10.4298 36.1676 10.2201 36.1454 8.02695 36.1454H5.64614L5.35472 36.516Z"
          fill="#4182F1"
        />
      </svg>
    </IconWrapper>
  );
}
export function ProgressStrokeIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="10"
        height="9"
        viewBox="0 0 10 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.93378 7.5C4.31868 8.16667 5.28093 8.16667 5.66583 7.5L8.69692 2.25C9.08182 1.58333 8.60069 0.75 7.83089 0.75H1.76872C0.998915 0.75 0.51779 1.58333 0.90269 2.25L3.93378 7.5Z"
          fill="white"
          stroke="#2B388F"
        />
      </svg>
    </IconWrapper>
  );
}

export function DownloadIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.625 11.875V15.0417C16.625 15.4616 16.4582 15.8643 16.1613 16.1613C15.8643 16.4582 15.4616 16.625 15.0417 16.625H3.95833C3.53841 16.625 3.13568 16.4582 2.83875 16.1613C2.54181 15.8643 2.375 15.4616 2.375 15.0417V11.875"
          stroke="currentColor"
          strokeWidth="1.58333"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="currentColor"
        />
        <path
          d="M5.54102 7.91669L9.49935 11.875L13.4577 7.91669"
          stroke="currentColor"
          strokeWidth="1.58333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.5 11.875V2.375"
          stroke="currentColor"
          strokeWidth="1.58333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
}
export function UploadIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="43"
        height="45"
        viewBox="0 0 43 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="43" height="45" rx="6" fill="#4182F1" />
        <path
          d="M31 26V30C31 30.5304 30.7893 31.0391 30.4142 31.4142C30.0391 31.7893 29.5304 32 29 32H15C14.4696 32 13.9609 31.7893 13.5858 31.4142C13.2107 31.0391 13 30.5304 13 30V26"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 19L22 14L17 19"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 14V26"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
}
export function UploadExcelIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="74"
        height="74"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.0352 38.9688L26.4052 45.5L22.0352 52.0312M30.7752 38.9688L26.4052 45.5L30.7752 52.0312"
          stroke="#4182F1"
          strokeWidth="3.20625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5312 36V55C14.5313 55.6299 14.7815 56.234 15.2269 56.6794C15.6723 57.1248 16.2764 57.375 16.9062 57.375H35.9062C36.5361 57.375 37.1402 57.1248 37.5856 56.6794C38.031 56.234 38.2812 55.6299 38.2812 55V36C38.2812 35.3701 38.031 34.766 37.5856 34.3206C37.1402 33.8752 36.5361 33.625 35.9062 33.625H16.9062C16.2764 33.625 15.6723 33.8752 15.2269 34.3206C14.7815 34.766 14.5313 35.3701 14.5312 36V36Z"
          stroke="#4182F1"
          strokeWidth="3.20625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.7109 33.625V24.7188C23.7109 24.0889 23.9612 23.4848 24.4066 23.0394C24.852 22.594 25.456 22.3438 26.0859 22.3438H33.588H37.339H39.2145M23.7109 57.375V66.2812C23.7109 66.9111 23.9612 67.5152 24.4066 67.9606C24.852 68.406 25.456 68.6562 26.0859 68.6562H56.0941C56.724 68.6562 57.328 68.406 57.7734 67.9606C58.2188 67.5152 58.4691 66.9111 58.4691 66.2812V24.7188C58.4691 24.0889 58.2188 23.4848 57.7734 23.0394C57.328 22.594 56.724 22.3438 56.0941 22.3438H52.343"
          stroke="#4182F1"
          strokeWidth="3.20625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.5 14.25L46.25 5M46.25 5L37 14.25M46.25 5V33.6875"
          stroke="#4182F1"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  );
}
export function RoleIcon({ fill = "currentcolor" }: IconProps): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3.09091C7.08873 3.09091 6.35 3.82353 6.35 4.72727C6.35 5.63101 7.08873 6.36364 8 6.36364C8.91127 6.36364 9.65 5.63101 9.65 4.72727C9.65 3.82353 8.91127 3.09091 8 3.09091ZM5.25 4.72727C5.25 3.22104 6.48122 2 8 2C9.51878 2 10.75 3.22104 10.75 4.72727C10.75 6.2335 9.51878 7.45455 8 7.45455C6.48122 7.45455 5.25 6.2335 5.25 4.72727ZM2.5 13.4545C2.5 10.4421 4.96244 8 8 8C11.0376 8 13.5 10.4421 13.5 13.4545C13.5 13.7558 13.2538 14 12.95 14C12.6462 14 12.4 13.7558 12.4 13.4545C12.4 11.3034 10.8304 9.51577 8.76507 9.15664L9.62568 11.9305C9.67921 12.103 9.64319 12.2907 9.52948 12.4317L8.42948 13.7953C8.3251 13.9247 8.16708 14 8 14C7.83292 14 7.6749 13.9247 7.57052 13.7953L6.47052 12.4317C6.35681 12.2907 6.32079 12.103 6.37432 11.9305L7.23493 9.15664C5.16958 9.51577 3.6 11.3034 3.6 13.4545C3.6 13.7558 3.35376 14 3.05 14C2.74624 14 2.5 13.7558 2.5 13.4545ZM8 10.4002L7.51125 11.9755L8 12.5814L8.48875 11.9755L8 10.4002Z"
          fill={fill}
        />
      </svg>
    </IconWrapper>
  );
}
export function PaginationLeftArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="29"
        height="30"
        viewBox="0 0 29 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2365 7.2458L9.70608 13.8533C9.56172 13.9964 9.44713 14.1668 9.36894 14.3545C9.29075 14.5422 9.25049 14.7435 9.25049 14.9468C9.25049 15.1501 9.29075 15.3514 9.36894 15.5391C9.44713 15.7268 9.56172 15.8972 9.70608 16.0403L16.2365 22.5708C16.3797 22.7151 16.55 22.8297 16.7377 22.9079C16.9254 22.9861 17.1267 23.0264 17.3301 23.0264C17.5334 23.0264 17.7347 22.9861 17.9224 22.9079C18.1101 22.8297 18.2804 22.7151 18.4236 22.5708C18.7105 22.2822 18.8715 21.8918 18.8715 21.4849C18.8715 21.078 18.7105 20.6877 18.4236 20.3991L12.9713 14.9468L18.4236 9.49449C18.7081 9.20762 18.8686 8.82041 18.8703 8.41636C18.8714 8.21365 18.8326 8.01272 18.7559 7.82506C18.6793 7.63741 18.5663 7.46673 18.4236 7.32281C18.2856 7.1733 18.1193 7.05262 17.9343 6.96774C17.7494 6.88287 17.5495 6.83548 17.3461 6.82832C17.1428 6.82116 16.94 6.85437 16.7495 6.92602C16.5591 6.99768 16.3847 7.10637 16.2365 7.2458Z"
          fill="#A3A3A3"
        />
      </svg>
    </IconWrapper>
  );
}
export function PaginationRightArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8025 7.2458L19.333 13.8533C19.4773 13.9964 19.5919 14.1668 19.6701 14.3545C19.7483 14.5422 19.7886 14.7435 19.7886 14.9468C19.7886 15.1501 19.7483 15.3514 19.6701 15.5391C19.5919 15.7268 19.4773 15.8972 19.333 16.0403L12.8025 22.5708C12.6594 22.7151 12.489 22.8297 12.3013 22.9079C12.1136 22.9861 11.9123 23.0264 11.709 23.0264C11.5057 23.0264 11.3044 22.9861 11.1167 22.9079C10.929 22.8297 10.7586 22.7151 10.6155 22.5708C10.3286 22.2822 10.1676 21.8918 10.1676 21.4849C10.1676 21.078 10.3286 20.6877 10.6155 20.3991L16.0678 14.9468L10.6155 9.49449C10.3309 9.20762 10.1705 8.82041 10.1688 8.41636C10.1676 8.21365 10.2065 8.01272 10.2831 7.82506C10.3598 7.63741 10.4727 7.46673 10.6155 7.32281C10.7535 7.1733 10.9198 7.05262 11.1047 6.96774C11.2897 6.88287 11.4896 6.83548 11.6929 6.82832C11.8963 6.82116 12.0991 6.85437 12.2895 6.92602C12.48 6.99768 12.6543 7.10637 12.8025 7.2458Z"
          fill="#A3A3A3"
        />
      </svg>
    </IconWrapper>
  );
}
export function PaginationDoubleRightArrow(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="29"
        height="30"
        viewBox="0 0 29 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.97979 7.2458L15.5102 13.8533C15.6546 13.9964 15.7692 14.1668 15.8474 14.3545C15.9256 14.5422 15.9658 14.7435 15.9658 14.9468C15.9658 15.1501 15.9256 15.3514 15.8474 15.5391C15.7692 15.7268 15.6546 15.8972 15.5102 16.0403L8.97979 22.5708C8.83661 22.7151 8.66626 22.8297 8.47857 22.9079C8.29089 22.9861 8.08957 23.0264 7.88625 23.0264C7.68293 23.0264 7.48161 22.9861 7.29393 22.9079C7.10624 22.8297 6.93589 22.7151 6.79271 22.5708C6.50585 22.2822 6.34483 21.8918 6.34483 21.4849C6.34483 21.078 6.50585 20.6877 6.79271 20.3991L12.245 14.9468L6.79271 9.49449C6.50817 9.20762 6.34775 8.82041 6.34605 8.41636C6.34488 8.21365 6.38373 8.01272 6.46038 7.82506C6.53702 7.63741 6.64996 7.46673 6.79271 7.32281C6.93074 7.1733 7.09703 7.05262 7.28197 6.96774C7.46691 6.88287 7.66683 6.83548 7.87019 6.82832C8.07355 6.82116 8.27632 6.85437 8.46677 6.92602C8.65722 6.99768 8.83159 7.10637 8.97979 7.2458Z"
          fill="#A3A3A3"
        />
        <path
          d="M16.1341 7.2458L22.6645 13.8533C22.8089 13.9964 22.9235 14.1668 23.0017 14.3545C23.0799 14.5422 23.1201 14.7435 23.1201 14.9468C23.1201 15.1501 23.0799 15.3514 23.0017 15.5391C22.9235 15.7268 22.8089 15.8972 22.6645 16.0403L16.1341 22.5708C15.9909 22.7151 15.8206 22.8297 15.6329 22.9079C15.4452 22.9861 15.2439 23.0264 15.0405 23.0264C14.8372 23.0264 14.6359 22.9861 14.4482 22.9079C14.2605 22.8297 14.0902 22.7151 13.947 22.5708C13.6601 22.2822 13.4991 21.8918 13.4991 21.4849C13.4991 21.078 13.6601 20.6877 13.947 20.3991L19.3993 14.9468L13.947 9.49449C13.6625 9.20762 13.502 8.82041 13.5003 8.41636C13.4992 8.21365 13.538 8.01272 13.6147 7.82506C13.6913 7.63741 13.8043 7.46673 13.947 7.32281C14.085 7.1733 14.2513 7.05262 14.4363 6.96774C14.6212 6.88287 14.8211 6.83548 15.0245 6.82832C15.2279 6.82116 15.4306 6.85437 15.6211 6.92602C15.8115 6.99768 15.9859 7.10637 16.1341 7.2458Z"
          fill="#A3A3A3"
        />
      </svg>
    </IconWrapper>
  );
}
export function LeftButtonIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2071 18.7071C14.8166 19.0976 14.1834 19.0976 13.7929 18.7071L7.79289 12.7071C7.40237 12.3166 7.40237 11.6834 7.79289 11.2929L13.7929 5.29289C14.1834 4.90237 14.8166 4.90237 15.2071 5.29289C15.5976 5.68342 15.5976 6.31658 15.2071 6.70711L9.91421 12L15.2071 17.2929C15.5976 17.6834 15.5976 18.3166 15.2071 18.7071Z"
          fill="currentColor"
          fillOpacity="0.65"
        />
      </svg>
    </IconWrapper>
  );
}
export function RightButtonIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.79289 5.29289C9.18342 4.90237 9.81658 4.90237 10.2071 5.29289L16.2071 11.2929C16.5976 11.6834 16.5976 12.3166 16.2071 12.7071L10.2071 18.7071C9.81658 19.0976 9.18342 19.0976 8.79289 18.7071C8.40237 18.3166 8.40237 17.6834 8.79289 17.2929L14.0858 12L8.79289 6.70711C8.40237 6.31658 8.40237 5.68342 8.79289 5.29289Z"
          fill="currentColor"
          fillOpacity="0.65"
        />
      </svg>
    </IconWrapper>
  );
}
export function SideBarIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          r="19"
          transform="matrix(-1 8.74228e-08 8.74228e-08 1 19 19)"
          fill="#4182F1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7926 25.7071C12.1832 26.0976 12.8163 26.0976 13.2069 25.7071L19.2069 19.7071C19.5974 19.3166 19.5974 18.6834 19.2069 18.2929L13.2069 12.2929C12.8163 11.9024 12.1832 11.9024 11.7926 12.2929C11.4021 12.6834 11.4021 13.3166 11.7926 13.7071L17.0855 19L11.7926 24.2929C11.4021 24.6834 11.4021 25.3166 11.7926 25.7071Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7926 25.7071C20.1832 26.0976 20.8163 26.0976 21.2069 25.7071L27.2069 19.7071C27.5974 19.3166 27.5974 18.6834 27.2069 18.2929L21.2069 12.2929C20.8163 11.9024 20.1832 11.9024 19.7926 12.2929C19.4021 12.6834 19.4021 13.3166 19.7926 13.7071L25.0855 19L19.7926 24.2929C19.4021 24.6834 19.4021 25.3166 19.7926 25.7071Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  );
}
export function AssessmentIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3333 1.66668C13.3333 1.20644 13.7064 0.833344 14.1667 0.833344H18.3333C18.7198 0.833344 19.0556 1.09907 19.1444 1.47522C19.2332 1.85136 19.0517 2.23919 18.706 2.41203L5.37267 9.0787C5.19475 9.16766 4.99087 9.19004 4.79788 9.1418L1.46455 8.30846C1.01805 8.19684 0.746584 7.74439 0.858208 7.2979C0.969832 6.8514 1.42228 6.57993 1.86877 6.69156L4.90304 7.45012L14.8033 2.50001H14.1667C13.7064 2.50001 13.3333 2.12691 13.3333 1.66668ZM18.7714 4.29113C19.0171 4.44297 19.1667 4.71119 19.1667 5.00001V15.8333C19.1667 16.2936 18.7936 16.6667 18.3333 16.6667H15C14.5398 16.6667 14.1667 16.2936 14.1667 15.8333V6.66668C14.1667 6.35103 14.345 6.06248 14.6273 5.92132L17.9606 4.25465C18.219 4.12549 18.5258 4.1393 18.7714 4.29113ZM15.8333 7.1817V15H17.5V6.34837L15.8333 7.1817ZM12.1048 7.62447C12.3505 7.77631 12.5 8.04453 12.5 8.33334V15.8333C12.5 16.2936 12.1269 16.6667 11.6667 16.6667H8.33333C7.87309 16.6667 7.49999 16.2936 7.49999 15.8333V10C7.49999 9.68437 7.67833 9.39581 7.96065 9.25465L11.294 7.58799C11.5523 7.45883 11.8591 7.47263 12.1048 7.62447ZM9.16666 10.515V15H10.8333V9.6817L9.16666 10.515ZM1.15382 10.1765C1.35608 10.0186 1.61982 9.96265 1.86877 10.0249L5.20211 10.8582C5.57308 10.951 5.83333 11.2843 5.83333 11.6667V15.8333C5.83333 16.2936 5.46023 16.6667 4.99999 16.6667H1.66666C1.20642 16.6667 0.833327 16.2936 0.833327 15.8333V10.8333C0.833327 10.5767 0.951553 10.3344 1.15382 10.1765ZM2.49999 11.9007V15H4.16666V12.3173L2.49999 11.9007ZM0.833327 18.3333C0.833327 17.8731 1.20642 17.5 1.66666 17.5H18.3333C18.7936 17.5 19.1667 17.8731 19.1667 18.3333C19.1667 18.7936 18.7936 19.1667 18.3333 19.1667H1.66666C1.20642 19.1667 0.833327 18.7936 0.833327 18.3333Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function StrategyIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M7.08333 11.6667C6.6231 11.6667 6.25 12.0398 6.25 12.5C6.25 12.9602 6.6231 13.3333 7.08333 13.3333H12.9167C13.3769 13.3333 13.75 12.9602 13.75 12.5C13.75 12.0398 13.3769 11.6667 12.9167 11.6667H7.08333Z"
            fill="currentColor"
          />
          <path
            d="M6.25 15C6.25 14.5398 6.6231 14.1667 7.08333 14.1667H10C10.4602 14.1667 10.8333 14.5398 10.8333 15C10.8333 15.4602 10.4602 15.8333 10 15.8333H7.08333C6.6231 15.8333 6.25 15.4602 6.25 15Z"
            fill="currentColor"
          />
          <path
            d="M13.0893 6.00593C13.4147 5.6805 13.4147 5.15286 13.0893 4.82742C12.7638 4.50198 12.2362 4.50198 11.9107 4.82742L9.16667 7.5715L8.08926 6.49409C7.76382 6.16865 7.23618 6.16865 6.91074 6.49409C6.58531 6.81952 6.58531 7.34716 6.91074 7.6726L8.57741 9.33926C8.90285 9.6647 9.43049 9.6647 9.75592 9.33926L13.0893 6.00593Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.16667 0.833344C3.24619 0.833344 2.5 1.57954 2.5 2.50001V17.5C2.5 18.4205 3.2462 19.1667 4.16667 19.1667H15.8333C16.7538 19.1667 17.5 18.4205 17.5 17.5V2.50001C17.5 1.57954 16.7538 0.833344 15.8333 0.833344H4.16667ZM4.16667 2.50001H15.8333V17.5H4.16667V2.50001Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function RoadMapIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2684 1.05171C15.5974 0.729859 16.125 0.735646 16.4469 1.06463L18.1045 2.75902C18.4249 3.08655 18.4208 3.61134 18.0953 3.93381L16.4377 5.57584C16.1107 5.89973 15.583 5.89724 15.2592 5.57027C14.9353 5.2433 14.9378 4.71566 15.2647 4.39177L15.4808 4.1777H5.07574C4.63039 4.1777 3.95673 4.30829 3.42022 4.68068C2.92882 5.02176 2.49998 5.59598 2.49998 6.65302C2.49998 7.71135 2.93028 8.29781 3.42639 8.64885C3.96555 9.03035 4.63868 9.16666 5.07574 9.16666H14.9974C15.6941 9.16666 16.711 9.36087 17.578 9.98427C18.488 10.6386 19.1666 11.7223 19.1666 13.3269C19.1666 14.9311 18.4885 16.0173 17.5803 16.675C16.7143 17.302 15.6972 17.5012 14.9974 17.5012H3.69645L3.93881 17.7413C4.26579 18.0652 4.26828 18.5928 3.94438 18.9198C3.62049 19.2468 3.09286 19.2493 2.76589 18.9254L1.10826 17.2833C0.782736 16.9609 0.778618 16.4361 1.09905 16.1085L2.75667 14.4142C3.07852 14.0852 3.60612 14.0794 3.93511 14.4012C4.26409 14.7231 4.26988 15.2507 3.94803 15.5797L3.69869 15.8345H14.9974C15.434 15.8345 16.0849 15.7001 16.6027 15.325C17.0784 14.9806 17.5 14.3963 17.5 13.3269C17.5 12.2579 17.0789 11.6782 16.605 11.3374C16.0881 10.9658 15.4371 10.8333 14.9974 10.8333H5.07574C4.37643 10.8333 3.34501 10.633 2.46372 10.0094C1.53938 9.35533 0.833313 8.26831 0.833313 6.65302C0.833313 5.03646 1.54084 3.95635 2.46989 3.3115C3.35384 2.69796 4.38472 2.51103 5.07574 2.51103H15.5303L15.2555 2.23015C14.9337 1.90116 14.9394 1.37356 15.2684 1.05171Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function TOMIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.01586 1.74337C1.75783 1.62428 1.4569 1.6449 1.21752 1.79806C0.978138 1.95122 0.833313 2.21582 0.833313 2.50001V15C0.833313 15.3251 1.0223 15.6204 1.31743 15.7566L6.72756 18.2536C6.77475 18.2759 6.82366 18.2935 6.87359 18.3065C6.99483 18.3381 7.12101 18.3417 7.24268 18.318C7.30244 18.3063 7.3611 18.2881 7.41755 18.2634L12.9041 15.912L17.9841 18.2566C18.2421 18.3757 18.5431 18.3551 18.7824 18.202C19.0218 18.0488 19.1666 17.7842 19.1666 17.5V5.00001C19.1666 4.67497 18.9776 4.37959 18.6825 4.24338L13.2701 1.74532C13.2343 1.72858 13.1976 1.71449 13.1603 1.70307C13.0807 1.67873 12.9986 1.66666 12.9166 1.66667C12.8513 1.66667 12.7859 1.67434 12.7217 1.68979C12.6744 1.70116 12.628 1.7167 12.583 1.73638L7.09585 4.088L2.01586 1.74337ZM12.0833 3.76379L7.91665 5.5495V16.2362L12.0833 14.4505V3.76379ZM13.75 14.4668L17.5 16.1976V5.53319L13.75 3.80243V14.4668ZM2.49998 3.80243L6.24998 5.53319V16.1976L2.49998 14.4668V3.80243Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function TeamsIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 2.5C8.61931 2.5 7.50002 3.61929 7.50002 5C7.50002 6.38071 8.61931 7.5 10 7.5C11.3807 7.5 12.5 6.38071 12.5 5C12.5 3.61929 11.3807 2.5 10 2.5ZM5.83335 5C5.83335 2.69882 7.69883 0.833336 10 0.833336C12.3012 0.833336 14.1667 2.69882 14.1667 5C14.1667 7.30119 12.3012 9.16667 10 9.16667C7.69883 9.16667 5.83335 7.30119 5.83335 5ZM1.66669 18.3333C1.66669 13.731 5.39766 10 10 10C14.6024 10 18.3334 13.731 18.3334 18.3333C18.3334 18.7936 17.9603 19.1667 17.5 19.1667C17.0398 19.1667 16.6667 18.7936 16.6667 18.3333C16.6667 14.6514 13.6819 11.6667 10 11.6667C6.31813 11.6667 3.33335 14.6514 3.33335 18.3333C3.33335 18.7936 2.96026 19.1667 2.50002 19.1667C2.03978 19.1667 1.66669 18.7936 1.66669 18.3333ZM10 13.3333C10.4603 13.3333 10.8334 13.7064 10.8334 14.1667V15.4167H12.0834C12.5436 15.4167 12.9167 15.7898 12.9167 16.25C12.9167 16.7102 12.5436 17.0833 12.0834 17.0833H10.8334V18.3333C10.8334 18.7936 10.4603 19.1667 10 19.1667C9.53978 19.1667 9.16669 18.7936 9.16669 18.3333V17.0833H7.91669C7.45645 17.0833 7.08335 16.7102 7.08335 16.25C7.08335 15.7898 7.45645 15.4167 7.91669 15.4167H9.16669V14.1667C9.16669 13.7064 9.53978 13.3333 10 13.3333Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function ImplementationIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M6.0059 3.50592C6.33134 3.18048 6.33134 2.65285 6.0059 2.32741C5.68046 2.00197 5.15283 2.00197 4.82739 2.32741L2.91665 4.23815L2.2559 3.57741C1.93046 3.25197 1.40283 3.25197 1.07739 3.57741C0.751954 3.90285 0.751954 4.43048 1.07739 4.75592L2.32739 6.00592C2.65283 6.33136 3.18046 6.33136 3.5059 6.00592L6.0059 3.50592Z"
            fill="currentColor"
          />
          <path
            d="M18.3333 3.33333H8.33331C7.87307 3.33333 7.49998 3.70643 7.49998 4.16667C7.49998 4.6269 7.87307 5 8.33331 5H18.3333C18.7935 5 19.1666 4.6269 19.1666 4.16667C19.1666 3.70643 18.7935 3.33333 18.3333 3.33333Z"
            fill="currentColor"
          />
          <path
            d="M8.33331 9.16667C7.87307 9.16667 7.49998 9.53976 7.49998 10C7.49998 10.4602 7.87307 10.8333 8.33331 10.8333H18.3333C18.7935 10.8333 19.1666 10.4602 19.1666 10C19.1666 9.53976 18.7935 9.16667 18.3333 9.16667H8.33331Z"
            fill="currentColor"
          />
          <path
            d="M7.49998 15.8333C7.49998 15.3731 7.87307 15 8.33331 15H18.3333C18.7935 15 19.1666 15.3731 19.1666 15.8333C19.1666 16.2936 18.7935 16.6667 18.3333 16.6667H8.33331C7.87307 16.6667 7.49998 16.2936 7.49998 15.8333Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.33331 7.5C1.9526 7.5 0.833313 8.61929 0.833313 10C0.833313 11.3807 1.9526 12.5 3.33331 12.5C4.71402 12.5 5.83331 11.3807 5.83331 10C5.83331 8.61929 4.71402 7.5 3.33331 7.5ZM2.49998 10C2.49998 9.53976 2.87308 9.16667 3.33331 9.16667C3.79355 9.16667 4.16665 9.53976 4.16665 10C4.16665 10.4602 3.79355 10.8333 3.33331 10.8333C2.87308 10.8333 2.49998 10.4602 2.49998 10Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.833313 15.8333C0.833313 14.4526 1.9526 13.3333 3.33331 13.3333C4.71402 13.3333 5.83331 14.4526 5.83331 15.8333C5.83331 17.214 4.71402 18.3333 3.33331 18.3333C1.9526 18.3333 0.833313 17.214 0.833313 15.8333ZM3.33331 15C2.87308 15 2.49998 15.3731 2.49998 15.8333C2.49998 16.2936 2.87308 16.6667 3.33331 16.6667C3.79355 16.6667 4.16665 16.2936 4.16665 15.8333C4.16665 15.3731 3.79355 15 3.33331 15Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function OrganizationIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M17.5 1.25C17.9274 1.25 18.2796 1.5717 18.3277 1.98615L18.3334 2.08333V12.5015C18.3334 12.9289 18.0117 13.2811 17.5972 13.3292L17.5 13.3348L10.8334 13.3342V15.9033L11.9108 14.8274C12.2112 14.527 12.6839 14.5039 13.0108 14.7581L13.0893 14.8274C13.3897 15.1278 13.4128 15.6005 13.1586 15.9274L13.0893 16.0059L10.5893 18.5059C10.5656 18.5296 10.5404 18.5519 10.514 18.5727L10.5893 18.5059C10.5598 18.5354 10.5286 18.5622 10.4961 18.5864C10.476 18.6013 10.4552 18.6152 10.4339 18.6283C10.4239 18.6345 10.4137 18.6404 10.4034 18.6461C10.3869 18.6552 10.3699 18.6639 10.3526 18.672C10.3384 18.6786 10.324 18.6848 10.3095 18.6906C10.293 18.6972 10.2765 18.7032 10.2598 18.7087C10.2474 18.7127 10.2346 18.7166 10.2217 18.7201C10.2037 18.7251 10.1856 18.7295 10.1673 18.7332C10.1528 18.7361 10.1383 18.7386 10.1237 18.7408C10.1068 18.7434 10.0892 18.7455 10.0715 18.747C10.0566 18.7482 10.0422 18.7491 10.0277 18.7495C10.0187 18.7498 10.0094 18.75 10 18.75L9.97314 18.7496C9.95813 18.7491 9.94313 18.7482 9.92816 18.7469L10 18.75C9.95784 18.75 9.91639 18.7469 9.87589 18.7408C9.86173 18.7386 9.84721 18.7361 9.83275 18.7331C9.8144 18.7295 9.79632 18.7251 9.77849 18.7202C9.76547 18.7166 9.75264 18.7127 9.7399 18.7086C9.72352 18.7032 9.70704 18.6972 9.69081 18.6907C9.67602 18.6848 9.66161 18.6786 9.64734 18.6719C9.63011 18.6639 9.61311 18.6552 9.59646 18.6459C9.58636 18.6404 9.57618 18.6345 9.5661 18.6283C9.54479 18.6152 9.52408 18.6013 9.50405 18.5864C9.49901 18.5827 9.49413 18.579 9.48927 18.5752C9.45963 18.5519 9.43449 18.5296 9.41077 18.5059L6.91077 16.0059C6.58533 15.6805 6.58533 15.1528 6.91077 14.8274C7.21117 14.527 7.68386 14.5039 8.01077 14.7581L8.08928 14.8274L9.16669 15.9033V13.3342L2.50002 13.3348C2.07266 13.3348 1.72043 13.0131 1.67229 12.5987L1.66669 12.5015V2.08333C1.66669 1.6231 2.03978 1.25 2.50002 1.25C2.92738 1.25 3.27961 1.5717 3.32775 1.98615L3.33335 2.08333V11.6675L9.98404 11.6668C9.98936 11.6667 9.99468 11.6667 10 11.6667L10.0159 11.6675H16.6667V2.08333C16.6667 1.65597 16.9884 1.30374 17.4028 1.25561L17.5 1.25ZM12.1732 3.91636L14.3393 6.07783C14.3618 6.10034 14.3831 6.12413 14.4029 6.14909L14.3393 6.07783C14.3735 6.1121 14.4045 6.14884 14.4315 6.18712C14.4412 6.20102 14.4507 6.21539 14.4598 6.23007C14.467 6.24167 14.4739 6.25355 14.4805 6.26554C14.4899 6.28263 14.4986 6.29996 14.5068 6.31762C14.5121 6.32918 14.5173 6.34112 14.5222 6.35316C14.5295 6.37088 14.5361 6.38895 14.5421 6.4073C14.5458 6.41899 14.5492 6.43039 14.5524 6.44184C14.5582 6.4617 14.5631 6.48235 14.5673 6.50329C14.5691 6.51343 14.5709 6.52347 14.5725 6.53353C14.5765 6.55652 14.5792 6.57993 14.581 6.60361C14.5814 6.61179 14.5819 6.61959 14.5823 6.62738C14.5831 6.64018 14.5834 6.6536 14.5834 6.66708L14.5826 6.69706C14.5822 6.70844 14.5816 6.71982 14.5807 6.73119L14.5834 6.66708C14.5834 6.71199 14.5798 6.75607 14.573 6.79905C14.5715 6.80665 14.5701 6.81472 14.5685 6.82276C14.5644 6.84631 14.5591 6.86891 14.5529 6.89113C14.5498 6.90091 14.5467 6.91152 14.5433 6.92207C14.5375 6.94136 14.5308 6.95969 14.5236 6.9777C14.5187 6.98901 14.5138 7.00044 14.5086 7.01178C14.4986 7.03452 14.4872 7.05684 14.4749 7.07855C14.4719 7.08324 14.4691 7.08792 14.4664 7.09259C14.4535 7.11486 14.4392 7.13642 14.4241 7.15724C14.4201 7.16209 14.4161 7.16746 14.412 7.1728L14.4073 7.17942C14.3846 7.2085 14.3601 7.23603 14.3338 7.26183L12.2557 9.37226C11.9328 9.70023 11.4051 9.70435 11.0772 9.38146C10.7744 9.08342 10.7476 8.61092 10.9993 8.28203L11.7592 7.5L6.25044 7.50042C5.7902 7.50042 5.4171 7.12732 5.4171 6.66708C5.4171 6.23972 5.7388 5.88749 6.15325 5.83936L6.25044 5.83375L11.7409 5.83333L11.072 5.16307C10.7719 4.86236 10.7492 4.38965 11.0038 4.063C11.303 3.72486 11.798 3.62397 12.1732 3.91636Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </IconWrapper>
  );
}
export function DashboardIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 3C2 2.44772 2.44772 2 3 2H10C10.5523 2 11 2.44772 11 3V8.5C11 9.05228 10.5523 9.5 10 9.5H3C2.44772 9.5 2 9.05228 2 8.5V3ZM4 4V7.5H9V4H4ZM13 3C13 2.44772 13.4477 2 14 2H21C21.5523 2 22 2.44772 22 3V11.5C22 12.0523 21.5523 12.5 21 12.5H14C13.4477 12.5 13 12.0523 13 11.5V3ZM15 4V10.5H20V4H15ZM2 12.5C2 11.9477 2.44772 11.5 3 11.5H10C10.5523 11.5 11 11.9477 11 12.5V21C11 21.5523 10.5523 22 10 22H3C2.44772 22 2 21.5523 2 21V12.5ZM4 13.5V20H9V13.5H4ZM13 15.5C13 14.9477 13.4477 14.5 14 14.5H21C21.5523 14.5 22 14.9477 22 15.5V21C22 21.5523 21.5523 22 21 22H14C13.4477 22 13 21.5523 13 21V15.5ZM15 16.5V20H20V16.5H15Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  );
}

export function RoundIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.5" cy="7.5" r="7.5" fill="currentColor" />
      </svg>
    </IconWrapper>
  );
}
export function RemoveIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5Z"
          fill="currentColor"
        />
        <path
          d="M3.75 6C3.75 5.72386 3.97386 5.5 4.25 5.5H7.75C8.02614 5.5 8.25 5.72386 8.25 6C8.25 6.27614 8.02614 6.5 7.75 6.5H4.25C3.97386 6.5 3.75 6.27614 3.75 6Z"
          fill="currentColor"
        />
      </svg>
    </IconWrapper>
  );
}
export function NotesIcon(): ReactElement {
  return (
    <IconWrapper>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.375 10.5C5.96079 10.5 5.625 10.8358 5.625 11.25C5.625 11.6642 5.96079 12 6.375 12H11.625C12.0392 12 12.375 11.6642 12.375 11.25C12.375 10.8358 12.0392 10.5 11.625 10.5H6.375Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          d="M5.625 13.5C5.625 13.0858 5.96079 12.75 6.375 12.75H9C9.41421 12.75 9.75 13.0858 9.75 13.5C9.75 13.9142 9.41421 14.25 9 14.25H6.375C5.96079 14.25 5.625 13.9142 5.625 13.5Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          d="M11.7803 5.40533C12.0732 5.11244 12.0732 4.63756 11.7803 4.34467C11.4874 4.05178 11.0126 4.05178 10.7197 4.34467L8.25 6.81434L7.28033 5.84467C6.98744 5.55178 6.51256 5.55178 6.21967 5.84467C5.92678 6.13756 5.92678 6.61244 6.21967 6.90533L7.71967 8.40533C8.01256 8.69822 8.48744 8.69822 8.78033 8.40533L11.7803 5.40533Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.75 0.75C2.92157 0.75 2.25 1.42157 2.25 2.25V15.75C2.25 16.5784 2.92158 17.25 3.75 17.25H14.25C15.0784 17.25 15.75 16.5784 15.75 15.75V2.25C15.75 1.42158 15.0784 0.75 14.25 0.75H3.75ZM3.75 2.25H14.25V15.75H3.75V2.25Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
      </svg>
    </IconWrapper>
  );
}
export default {
  AlertIcon,
  modalClose,
  hamburgerIcon,
  closeButton,
  whiteCloseButton,
  tick,
  SearchIcon,
  downArrow,
  Info,
  tick1,
  Tick2,
  Add,
  PriorityIndicator,
  InfoIcon,
  LinkIcon,
  ThreeDotsDropDown,
  refreshIcon,
  info1,
  Tick3,
  ProgressBreakICon,
  LineDot,
  DragIcon,
  CloseIcon,
  ArrowBack,
  ZoomOutIcon,
  ZoomInIcon,
  ProfileIcon,
  EditIcon,
  DeleteIcon,
  CloseIcon2,
  MoveIcon,
  LinkedinIcon,
  UserCIrcleIcon,
  LogoipsumIcon,
  PeersIcon,
  shadeOne,
  shadeTwo,
  shadeThree,
  MoveIconSmall,
  AddIconBlack,
  UserIcon,
  JobIcon,
  ProgressIcon,
  CalenderIcon,
  AddIcon,
  HighIcon,
  AccordionUpArrow,
  AccordionDownArrow,
  arrowRightIcon,
  UnAssignedIcon,
  DragImage,
  ProgressStrokeIcon,
  DownloadIcon,
  UploadIcon,
  UploadExcelIcon,
  RoleIcon,
  PaginationLeftArrow,
  PaginationRightArrow,
  PaginationDoubleRightArrow,
  RightButtonIcon,
  LeftButtonIcon,
  SideBarIcon,
  AssessmentIcon,
  StrategyIcon,
  RoadMapIcon,
  TOMIcon,
  TeamsIcon,
  ImplementationIcon,
  OrganizationIcon,
  DashboardIcon,
  RoundIcon,
  RemoveIcon,
  NotesIcon,
};
